var map = {
	"./": [
		92422,
		9,
		63524,
		92422
	],
	"./_lib/buildFormatLongFn": [
		49484,
		7,
		49484
	],
	"./_lib/buildFormatLongFn/": [
		49484,
		7,
		49484
	],
	"./_lib/buildFormatLongFn/index": [
		49484,
		7,
		49484
	],
	"./_lib/buildFormatLongFn/index.js": [
		49484,
		7,
		49484
	],
	"./_lib/buildLocalizeFn": [
		15916,
		7,
		15916
	],
	"./_lib/buildLocalizeFn/": [
		15916,
		7,
		15916
	],
	"./_lib/buildLocalizeFn/index": [
		15916,
		7,
		15916
	],
	"./_lib/buildLocalizeFn/index.js": [
		15916,
		7,
		15916
	],
	"./_lib/buildMatchFn": [
		63309,
		7,
		63309
	],
	"./_lib/buildMatchFn/": [
		63309,
		7,
		63309
	],
	"./_lib/buildMatchFn/index": [
		63309,
		7,
		63309
	],
	"./_lib/buildMatchFn/index.js": [
		63309,
		7,
		63309
	],
	"./_lib/buildMatchPatternFn": [
		25101,
		7,
		25101
	],
	"./_lib/buildMatchPatternFn/": [
		25101,
		7,
		25101
	],
	"./_lib/buildMatchPatternFn/index": [
		25101,
		7,
		25101
	],
	"./_lib/buildMatchPatternFn/index.js": [
		25101,
		7,
		25101
	],
	"./af": [
		77978,
		9,
		77978
	],
	"./af/": [
		77978,
		9,
		77978
	],
	"./af/_lib/formatDistance": [
		27553,
		7,
		27553
	],
	"./af/_lib/formatDistance/": [
		27553,
		7,
		27553
	],
	"./af/_lib/formatDistance/index": [
		27553,
		7,
		27553
	],
	"./af/_lib/formatDistance/index.js": [
		27553,
		7,
		27553
	],
	"./af/_lib/formatLong": [
		66329,
		7,
		66329
	],
	"./af/_lib/formatLong/": [
		66329,
		7,
		66329
	],
	"./af/_lib/formatLong/index": [
		66329,
		7,
		66329
	],
	"./af/_lib/formatLong/index.js": [
		66329,
		7,
		66329
	],
	"./af/_lib/formatRelative": [
		42001,
		7,
		42001
	],
	"./af/_lib/formatRelative/": [
		42001,
		7,
		42001
	],
	"./af/_lib/formatRelative/index": [
		42001,
		7,
		42001
	],
	"./af/_lib/formatRelative/index.js": [
		42001,
		7,
		42001
	],
	"./af/_lib/localize": [
		27944,
		7,
		27944
	],
	"./af/_lib/localize/": [
		27944,
		7,
		27944
	],
	"./af/_lib/localize/index": [
		27944,
		7,
		27944
	],
	"./af/_lib/localize/index.js": [
		27944,
		7,
		27944
	],
	"./af/_lib/match": [
		24557,
		7,
		24557
	],
	"./af/_lib/match/": [
		24557,
		7,
		24557
	],
	"./af/_lib/match/index": [
		24557,
		7,
		24557
	],
	"./af/_lib/match/index.js": [
		24557,
		7,
		24557
	],
	"./af/index": [
		78998,
		7,
		78998
	],
	"./af/index.d": [
		62154,
		9,
		62154
	],
	"./af/index.d.ts": [
		62154,
		9,
		62154
	],
	"./af/index.js": [
		78998,
		7,
		78998
	],
	"./af/index.js.flow": [
		49368,
		1,
		49368
	],
	"./af/package": [
		77770,
		3,
		77770
	],
	"./af/package.json": [
		77770,
		3,
		77770
	],
	"./ar-DZ": [
		65434,
		9,
		65434
	],
	"./ar-DZ/": [
		65434,
		9,
		65434
	],
	"./ar-DZ/_lib/formatDistance": [
		71086,
		7,
		71086
	],
	"./ar-DZ/_lib/formatDistance/": [
		71086,
		7,
		71086
	],
	"./ar-DZ/_lib/formatDistance/index": [
		71086,
		7,
		71086
	],
	"./ar-DZ/_lib/formatDistance/index.js": [
		71086,
		7,
		71086
	],
	"./ar-DZ/_lib/formatLong": [
		38645,
		7,
		38645
	],
	"./ar-DZ/_lib/formatLong/": [
		38645,
		7,
		38645
	],
	"./ar-DZ/_lib/formatLong/index": [
		38645,
		7,
		38645
	],
	"./ar-DZ/_lib/formatLong/index.js": [
		38645,
		7,
		38645
	],
	"./ar-DZ/_lib/formatRelative": [
		85535,
		7,
		85535
	],
	"./ar-DZ/_lib/formatRelative/": [
		85535,
		7,
		85535
	],
	"./ar-DZ/_lib/formatRelative/index": [
		85535,
		7,
		85535
	],
	"./ar-DZ/_lib/formatRelative/index.js": [
		85535,
		7,
		85535
	],
	"./ar-DZ/_lib/localize": [
		74236,
		7,
		74236
	],
	"./ar-DZ/_lib/localize/": [
		74236,
		7,
		74236
	],
	"./ar-DZ/_lib/localize/index": [
		74236,
		7,
		74236
	],
	"./ar-DZ/_lib/localize/index.js": [
		74236,
		7,
		74236
	],
	"./ar-DZ/_lib/match": [
		54399,
		7,
		54399
	],
	"./ar-DZ/_lib/match/": [
		54399,
		7,
		54399
	],
	"./ar-DZ/_lib/match/index": [
		54399,
		7,
		54399
	],
	"./ar-DZ/_lib/match/index.js": [
		54399,
		7,
		54399
	],
	"./ar-DZ/index": [
		67984,
		7,
		67984
	],
	"./ar-DZ/index.d": [
		21925,
		9,
		21925
	],
	"./ar-DZ/index.d.ts": [
		21925,
		9,
		21925
	],
	"./ar-DZ/index.js": [
		67984,
		7,
		67984
	],
	"./ar-DZ/index.js.flow": [
		72213,
		1,
		72213
	],
	"./ar-DZ/package": [
		14728,
		3,
		14728
	],
	"./ar-DZ/package.json": [
		14728,
		3,
		14728
	],
	"./ar-MA": [
		8258,
		9,
		8258
	],
	"./ar-MA/": [
		8258,
		9,
		8258
	],
	"./ar-MA/_lib/formatDistance": [
		94327,
		7,
		94327
	],
	"./ar-MA/_lib/formatDistance/": [
		94327,
		7,
		94327
	],
	"./ar-MA/_lib/formatDistance/index": [
		94327,
		7,
		94327
	],
	"./ar-MA/_lib/formatDistance/index.js": [
		94327,
		7,
		94327
	],
	"./ar-MA/_lib/formatLong": [
		13778,
		7,
		13778
	],
	"./ar-MA/_lib/formatLong/": [
		13778,
		7,
		13778
	],
	"./ar-MA/_lib/formatLong/index": [
		13778,
		7,
		13778
	],
	"./ar-MA/_lib/formatLong/index.js": [
		13778,
		7,
		13778
	],
	"./ar-MA/_lib/formatRelative": [
		45288,
		7,
		45288
	],
	"./ar-MA/_lib/formatRelative/": [
		45288,
		7,
		45288
	],
	"./ar-MA/_lib/formatRelative/index": [
		45288,
		7,
		45288
	],
	"./ar-MA/_lib/formatRelative/index.js": [
		45288,
		7,
		45288
	],
	"./ar-MA/_lib/localize": [
		52121,
		7,
		52121
	],
	"./ar-MA/_lib/localize/": [
		52121,
		7,
		52121
	],
	"./ar-MA/_lib/localize/index": [
		52121,
		7,
		52121
	],
	"./ar-MA/_lib/localize/index.js": [
		52121,
		7,
		52121
	],
	"./ar-MA/_lib/match": [
		78586,
		7,
		78586
	],
	"./ar-MA/_lib/match/": [
		78586,
		7,
		78586
	],
	"./ar-MA/_lib/match/index": [
		78586,
		7,
		78586
	],
	"./ar-MA/_lib/match/index.js": [
		78586,
		7,
		78586
	],
	"./ar-MA/index": [
		99958,
		7,
		99958
	],
	"./ar-MA/index.d": [
		16945,
		9,
		16945
	],
	"./ar-MA/index.d.ts": [
		16945,
		9,
		16945
	],
	"./ar-MA/index.js": [
		99958,
		7,
		99958
	],
	"./ar-MA/index.js.flow": [
		6656,
		1,
		6656
	],
	"./ar-MA/package": [
		52700,
		3,
		52700
	],
	"./ar-MA/package.json": [
		52700,
		3,
		52700
	],
	"./ar-SA": [
		11132,
		9,
		11132
	],
	"./ar-SA/": [
		11132,
		9,
		11132
	],
	"./ar-SA/_lib/formatDistance": [
		79655,
		7,
		79655
	],
	"./ar-SA/_lib/formatDistance/": [
		79655,
		7,
		79655
	],
	"./ar-SA/_lib/formatDistance/index": [
		79655,
		7,
		79655
	],
	"./ar-SA/_lib/formatDistance/index.js": [
		79655,
		7,
		79655
	],
	"./ar-SA/_lib/formatLong": [
		30123,
		7,
		30123
	],
	"./ar-SA/_lib/formatLong/": [
		30123,
		7,
		30123
	],
	"./ar-SA/_lib/formatLong/index": [
		30123,
		7,
		30123
	],
	"./ar-SA/_lib/formatLong/index.js": [
		30123,
		7,
		30123
	],
	"./ar-SA/_lib/formatRelative": [
		19765,
		7,
		19765
	],
	"./ar-SA/_lib/formatRelative/": [
		19765,
		7,
		19765
	],
	"./ar-SA/_lib/formatRelative/index": [
		19765,
		7,
		19765
	],
	"./ar-SA/_lib/formatRelative/index.js": [
		19765,
		7,
		19765
	],
	"./ar-SA/_lib/localize": [
		15620,
		7,
		15620
	],
	"./ar-SA/_lib/localize/": [
		15620,
		7,
		15620
	],
	"./ar-SA/_lib/localize/index": [
		15620,
		7,
		15620
	],
	"./ar-SA/_lib/localize/index.js": [
		15620,
		7,
		15620
	],
	"./ar-SA/_lib/match": [
		42376,
		7,
		42376
	],
	"./ar-SA/_lib/match/": [
		42376,
		7,
		42376
	],
	"./ar-SA/_lib/match/index": [
		42376,
		7,
		42376
	],
	"./ar-SA/_lib/match/index.js": [
		42376,
		7,
		42376
	],
	"./ar-SA/index": [
		48297,
		7,
		48297
	],
	"./ar-SA/index.d": [
		3876,
		9,
		3876
	],
	"./ar-SA/index.d.ts": [
		3876,
		9,
		3876
	],
	"./ar-SA/index.js": [
		48297,
		7,
		48297
	],
	"./ar-SA/index.js.flow": [
		44032,
		1,
		44032
	],
	"./ar-SA/package": [
		6170,
		3,
		6170
	],
	"./ar-SA/package.json": [
		6170,
		3,
		6170
	],
	"./az": [
		47101,
		9,
		47101
	],
	"./az/": [
		47101,
		9,
		47101
	],
	"./az/_lib/formatDistance": [
		39263,
		7,
		39263
	],
	"./az/_lib/formatDistance/": [
		39263,
		7,
		39263
	],
	"./az/_lib/formatDistance/index": [
		39263,
		7,
		39263
	],
	"./az/_lib/formatDistance/index.js": [
		39263,
		7,
		39263
	],
	"./az/_lib/formatLong": [
		78909,
		7,
		78909
	],
	"./az/_lib/formatLong/": [
		78909,
		7,
		78909
	],
	"./az/_lib/formatLong/index": [
		78909,
		7,
		78909
	],
	"./az/_lib/formatLong/index.js": [
		78909,
		7,
		78909
	],
	"./az/_lib/formatRelative": [
		87173,
		7,
		87173
	],
	"./az/_lib/formatRelative/": [
		87173,
		7,
		87173
	],
	"./az/_lib/formatRelative/index": [
		87173,
		7,
		87173
	],
	"./az/_lib/formatRelative/index.js": [
		87173,
		7,
		87173
	],
	"./az/_lib/localize": [
		71744,
		7,
		71744
	],
	"./az/_lib/localize/": [
		71744,
		7,
		71744
	],
	"./az/_lib/localize/index": [
		71744,
		7,
		71744
	],
	"./az/_lib/localize/index.js": [
		71744,
		7,
		71744
	],
	"./az/_lib/match": [
		40457,
		7,
		40457
	],
	"./az/_lib/match/": [
		40457,
		7,
		40457
	],
	"./az/_lib/match/index": [
		40457,
		7,
		40457
	],
	"./az/_lib/match/index.js": [
		40457,
		7,
		40457
	],
	"./az/index": [
		51426,
		7,
		51426
	],
	"./az/index.d": [
		95984,
		9,
		95984
	],
	"./az/index.d.ts": [
		95984,
		9,
		95984
	],
	"./az/index.js": [
		51426,
		7,
		51426
	],
	"./az/index.js.flow": [
		75997,
		1,
		75997
	],
	"./az/package": [
		64362,
		3,
		64362
	],
	"./az/package.json": [
		64362,
		3,
		64362
	],
	"./be": [
		63524,
		9,
		63524
	],
	"./be/": [
		63524,
		9,
		63524
	],
	"./be/_lib/formatDistance": [
		20612,
		7,
		20612
	],
	"./be/_lib/formatDistance/": [
		20612,
		7,
		20612
	],
	"./be/_lib/formatDistance/index": [
		20612,
		7,
		20612
	],
	"./be/_lib/formatDistance/index.js": [
		20612,
		7,
		20612
	],
	"./be/_lib/formatLong": [
		30631,
		7,
		30631
	],
	"./be/_lib/formatLong/": [
		30631,
		7,
		30631
	],
	"./be/_lib/formatLong/index": [
		30631,
		7,
		30631
	],
	"./be/_lib/formatLong/index.js": [
		30631,
		7,
		30631
	],
	"./be/_lib/formatRelative": [
		86196,
		7,
		86196
	],
	"./be/_lib/formatRelative/": [
		86196,
		7,
		86196
	],
	"./be/_lib/formatRelative/index": [
		86196,
		7,
		86196
	],
	"./be/_lib/formatRelative/index.js": [
		86196,
		7,
		86196
	],
	"./be/_lib/localize": [
		63622,
		7,
		63622
	],
	"./be/_lib/localize/": [
		63622,
		7,
		63622
	],
	"./be/_lib/localize/index": [
		63622,
		7,
		63622
	],
	"./be/_lib/localize/index.js": [
		63622,
		7,
		63622
	],
	"./be/_lib/match": [
		68969,
		7,
		68969
	],
	"./be/_lib/match/": [
		68969,
		7,
		68969
	],
	"./be/_lib/match/index": [
		68969,
		7,
		68969
	],
	"./be/_lib/match/index.js": [
		68969,
		7,
		68969
	],
	"./be/index": [
		62557,
		7,
		62557
	],
	"./be/index.d": [
		30492,
		9,
		63524,
		30492
	],
	"./be/index.d.ts": [
		30492,
		9,
		63524,
		30492
	],
	"./be/index.js": [
		62557,
		7,
		62557
	],
	"./be/index.js.flow": [
		26465,
		1,
		26465
	],
	"./be/package": [
		34285,
		3,
		34285
	],
	"./be/package.json": [
		34285,
		3,
		34285
	],
	"./bg": [
		75779,
		9,
		75779
	],
	"./bg/": [
		75779,
		9,
		75779
	],
	"./bg/_lib/formatDistance": [
		20591,
		7,
		20591
	],
	"./bg/_lib/formatDistance/": [
		20591,
		7,
		20591
	],
	"./bg/_lib/formatDistance/index": [
		20591,
		7,
		20591
	],
	"./bg/_lib/formatDistance/index.js": [
		20591,
		7,
		20591
	],
	"./bg/_lib/formatLong": [
		67050,
		7,
		67050
	],
	"./bg/_lib/formatLong/": [
		67050,
		7,
		67050
	],
	"./bg/_lib/formatLong/index": [
		67050,
		7,
		67050
	],
	"./bg/_lib/formatLong/index.js": [
		67050,
		7,
		67050
	],
	"./bg/_lib/formatRelative": [
		30236,
		7,
		30236
	],
	"./bg/_lib/formatRelative/": [
		30236,
		7,
		30236
	],
	"./bg/_lib/formatRelative/index": [
		30236,
		7,
		30236
	],
	"./bg/_lib/formatRelative/index.js": [
		30236,
		7,
		30236
	],
	"./bg/_lib/localize": [
		10932,
		7,
		10932
	],
	"./bg/_lib/localize/": [
		10932,
		7,
		10932
	],
	"./bg/_lib/localize/index": [
		10932,
		7,
		10932
	],
	"./bg/_lib/localize/index.js": [
		10932,
		7,
		10932
	],
	"./bg/_lib/match": [
		94623,
		7,
		94623
	],
	"./bg/_lib/match/": [
		94623,
		7,
		94623
	],
	"./bg/_lib/match/index": [
		94623,
		7,
		94623
	],
	"./bg/_lib/match/index.js": [
		94623,
		7,
		94623
	],
	"./bg/index": [
		23755,
		7,
		23755
	],
	"./bg/index.d": [
		29568,
		9,
		29568
	],
	"./bg/index.d.ts": [
		29568,
		9,
		29568
	],
	"./bg/index.js": [
		23755,
		7,
		23755
	],
	"./bg/index.js.flow": [
		45142,
		1,
		45142
	],
	"./bg/package": [
		15244,
		3,
		15244
	],
	"./bg/package.json": [
		15244,
		3,
		15244
	],
	"./bn": [
		63601,
		9,
		63601
	],
	"./bn/": [
		63601,
		9,
		63601
	],
	"./bn/_lib/formatDistance": [
		39225,
		7,
		39225
	],
	"./bn/_lib/formatDistance/": [
		39225,
		7,
		39225
	],
	"./bn/_lib/formatDistance/index": [
		39225,
		7,
		39225
	],
	"./bn/_lib/formatDistance/index.js": [
		39225,
		7,
		39225
	],
	"./bn/_lib/formatLong": [
		42658,
		7,
		42658
	],
	"./bn/_lib/formatLong/": [
		42658,
		7,
		42658
	],
	"./bn/_lib/formatLong/index": [
		42658,
		7,
		42658
	],
	"./bn/_lib/formatLong/index.js": [
		42658,
		7,
		42658
	],
	"./bn/_lib/formatRelative": [
		80787,
		7,
		80787
	],
	"./bn/_lib/formatRelative/": [
		80787,
		7,
		80787
	],
	"./bn/_lib/formatRelative/index": [
		80787,
		7,
		80787
	],
	"./bn/_lib/formatRelative/index.js": [
		80787,
		7,
		80787
	],
	"./bn/_lib/localize": [
		11450,
		7,
		11450
	],
	"./bn/_lib/localize/": [
		11450,
		7,
		11450
	],
	"./bn/_lib/localize/index": [
		11450,
		7,
		11450
	],
	"./bn/_lib/localize/index.js": [
		11450,
		7,
		11450
	],
	"./bn/_lib/match": [
		40828,
		7,
		40828
	],
	"./bn/_lib/match/": [
		40828,
		7,
		40828
	],
	"./bn/_lib/match/index": [
		40828,
		7,
		40828
	],
	"./bn/_lib/match/index.js": [
		40828,
		7,
		40828
	],
	"./bn/index": [
		96340,
		7,
		96340
	],
	"./bn/index.d": [
		80157,
		9,
		80157
	],
	"./bn/index.d.ts": [
		80157,
		9,
		80157
	],
	"./bn/index.js": [
		96340,
		7,
		96340
	],
	"./bn/index.js.flow": [
		50042,
		1,
		50042
	],
	"./bn/package": [
		60893,
		3,
		60893
	],
	"./bn/package.json": [
		60893,
		3,
		60893
	],
	"./ca": [
		90901,
		9,
		90901
	],
	"./ca/": [
		90901,
		9,
		90901
	],
	"./ca/_lib/formatDistance": [
		29869,
		7,
		29869
	],
	"./ca/_lib/formatDistance/": [
		29869,
		7,
		29869
	],
	"./ca/_lib/formatDistance/index": [
		29869,
		7,
		29869
	],
	"./ca/_lib/formatDistance/index.js": [
		29869,
		7,
		29869
	],
	"./ca/_lib/formatLong": [
		78692,
		7,
		78692
	],
	"./ca/_lib/formatLong/": [
		78692,
		7,
		78692
	],
	"./ca/_lib/formatLong/index": [
		78692,
		7,
		78692
	],
	"./ca/_lib/formatLong/index.js": [
		78692,
		7,
		78692
	],
	"./ca/_lib/formatRelative": [
		47548,
		7,
		47548
	],
	"./ca/_lib/formatRelative/": [
		47548,
		7,
		47548
	],
	"./ca/_lib/formatRelative/index": [
		47548,
		7,
		47548
	],
	"./ca/_lib/formatRelative/index.js": [
		47548,
		7,
		47548
	],
	"./ca/_lib/localize": [
		45694,
		7,
		45694
	],
	"./ca/_lib/localize/": [
		45694,
		7,
		45694
	],
	"./ca/_lib/localize/index": [
		45694,
		7,
		45694
	],
	"./ca/_lib/localize/index.js": [
		45694,
		7,
		45694
	],
	"./ca/_lib/match": [
		63284,
		7,
		63284
	],
	"./ca/_lib/match/": [
		63284,
		7,
		63284
	],
	"./ca/_lib/match/index": [
		63284,
		7,
		63284
	],
	"./ca/_lib/match/index.js": [
		63284,
		7,
		63284
	],
	"./ca/index": [
		74536,
		7,
		74536
	],
	"./ca/index.d": [
		61979,
		9,
		61979
	],
	"./ca/index.d.ts": [
		61979,
		9,
		61979
	],
	"./ca/index.js": [
		74536,
		7,
		74536
	],
	"./ca/index.js.flow": [
		51261,
		1,
		51261
	],
	"./ca/package": [
		54806,
		3,
		54806
	],
	"./ca/package.json": [
		54806,
		3,
		54806
	],
	"./cs": [
		70183,
		9,
		70183
	],
	"./cs/": [
		70183,
		9,
		70183
	],
	"./cs/_lib/formatDistance": [
		46107,
		7,
		46107
	],
	"./cs/_lib/formatDistance/": [
		46107,
		7,
		46107
	],
	"./cs/_lib/formatDistance/index": [
		46107,
		7,
		46107
	],
	"./cs/_lib/formatDistance/index.js": [
		46107,
		7,
		46107
	],
	"./cs/_lib/formatLong": [
		27493,
		7,
		27493
	],
	"./cs/_lib/formatLong/": [
		27493,
		7,
		27493
	],
	"./cs/_lib/formatLong/index": [
		27493,
		7,
		27493
	],
	"./cs/_lib/formatLong/index.js": [
		27493,
		7,
		27493
	],
	"./cs/_lib/formatRelative": [
		56911,
		7,
		56911
	],
	"./cs/_lib/formatRelative/": [
		56911,
		7,
		56911
	],
	"./cs/_lib/formatRelative/index": [
		56911,
		7,
		56911
	],
	"./cs/_lib/formatRelative/index.js": [
		56911,
		7,
		56911
	],
	"./cs/_lib/localize": [
		829,
		7,
		829
	],
	"./cs/_lib/localize/": [
		829,
		7,
		829
	],
	"./cs/_lib/localize/index": [
		829,
		7,
		829
	],
	"./cs/_lib/localize/index.js": [
		829,
		7,
		829
	],
	"./cs/_lib/match": [
		11227,
		7,
		11227
	],
	"./cs/_lib/match/": [
		11227,
		7,
		11227
	],
	"./cs/_lib/match/index": [
		11227,
		7,
		11227
	],
	"./cs/_lib/match/index.js": [
		11227,
		7,
		11227
	],
	"./cs/index": [
		2269,
		7,
		2269
	],
	"./cs/index.d": [
		72209,
		9,
		72209
	],
	"./cs/index.d.ts": [
		72209,
		9,
		72209
	],
	"./cs/index.js": [
		2269,
		7,
		2269
	],
	"./cs/index.js.flow": [
		14808,
		1,
		14808
	],
	"./cs/package": [
		79878,
		3,
		79878
	],
	"./cs/package.json": [
		79878,
		3,
		79878
	],
	"./cy": [
		74595,
		9,
		74595
	],
	"./cy/": [
		74595,
		9,
		74595
	],
	"./cy/_lib/formatDistance": [
		7497,
		7,
		7497
	],
	"./cy/_lib/formatDistance/": [
		7497,
		7,
		7497
	],
	"./cy/_lib/formatDistance/index": [
		7497,
		7,
		7497
	],
	"./cy/_lib/formatDistance/index.js": [
		7497,
		7,
		7497
	],
	"./cy/_lib/formatLong": [
		53361,
		7,
		53361
	],
	"./cy/_lib/formatLong/": [
		53361,
		7,
		53361
	],
	"./cy/_lib/formatLong/index": [
		53361,
		7,
		53361
	],
	"./cy/_lib/formatLong/index.js": [
		53361,
		7,
		53361
	],
	"./cy/_lib/formatRelative": [
		11968,
		7,
		11968
	],
	"./cy/_lib/formatRelative/": [
		11968,
		7,
		11968
	],
	"./cy/_lib/formatRelative/index": [
		11968,
		7,
		11968
	],
	"./cy/_lib/formatRelative/index.js": [
		11968,
		7,
		11968
	],
	"./cy/_lib/localize": [
		47506,
		7,
		47506
	],
	"./cy/_lib/localize/": [
		47506,
		7,
		47506
	],
	"./cy/_lib/localize/index": [
		47506,
		7,
		47506
	],
	"./cy/_lib/localize/index.js": [
		47506,
		7,
		47506
	],
	"./cy/_lib/match": [
		84727,
		7,
		84727
	],
	"./cy/_lib/match/": [
		84727,
		7,
		84727
	],
	"./cy/_lib/match/index": [
		84727,
		7,
		84727
	],
	"./cy/_lib/match/index.js": [
		84727,
		7,
		84727
	],
	"./cy/index": [
		72907,
		7,
		72907
	],
	"./cy/index.d": [
		77241,
		9,
		77241
	],
	"./cy/index.d.ts": [
		77241,
		9,
		77241
	],
	"./cy/index.js": [
		72907,
		7,
		72907
	],
	"./cy/index.js.flow": [
		44492,
		1,
		44492
	],
	"./cy/package": [
		25258,
		3,
		25258
	],
	"./cy/package.json": [
		25258,
		3,
		25258
	],
	"./da": [
		16691,
		9,
		16691
	],
	"./da/": [
		16691,
		9,
		16691
	],
	"./da/_lib/formatDistance": [
		5851,
		7,
		5851
	],
	"./da/_lib/formatDistance/": [
		5851,
		7,
		5851
	],
	"./da/_lib/formatDistance/index": [
		5851,
		7,
		5851
	],
	"./da/_lib/formatDistance/index.js": [
		5851,
		7,
		5851
	],
	"./da/_lib/formatLong": [
		80013,
		7,
		80013
	],
	"./da/_lib/formatLong/": [
		80013,
		7,
		80013
	],
	"./da/_lib/formatLong/index": [
		80013,
		7,
		80013
	],
	"./da/_lib/formatLong/index.js": [
		80013,
		7,
		80013
	],
	"./da/_lib/formatRelative": [
		22650,
		7,
		22650
	],
	"./da/_lib/formatRelative/": [
		22650,
		7,
		22650
	],
	"./da/_lib/formatRelative/index": [
		22650,
		7,
		22650
	],
	"./da/_lib/formatRelative/index.js": [
		22650,
		7,
		22650
	],
	"./da/_lib/localize": [
		29205,
		7,
		29205
	],
	"./da/_lib/localize/": [
		29205,
		7,
		29205
	],
	"./da/_lib/localize/index": [
		29205,
		7,
		29205
	],
	"./da/_lib/localize/index.js": [
		29205,
		7,
		29205
	],
	"./da/_lib/match": [
		51217,
		7,
		51217
	],
	"./da/_lib/match/": [
		51217,
		7,
		51217
	],
	"./da/_lib/match/index": [
		51217,
		7,
		51217
	],
	"./da/_lib/match/index.js": [
		51217,
		7,
		51217
	],
	"./da/index": [
		90961,
		7,
		90961
	],
	"./da/index.d": [
		80751,
		9,
		80751
	],
	"./da/index.d.ts": [
		80751,
		9,
		80751
	],
	"./da/index.js": [
		90961,
		7,
		90961
	],
	"./da/index.js.flow": [
		91207,
		1,
		91207
	],
	"./da/package": [
		2750,
		3,
		2750
	],
	"./da/package.json": [
		2750,
		3,
		2750
	],
	"./de": [
		31320,
		9,
		31320
	],
	"./de/": [
		31320,
		9,
		31320
	],
	"./de/_lib/formatDistance": [
		84318,
		7,
		84318
	],
	"./de/_lib/formatDistance/": [
		84318,
		7,
		84318
	],
	"./de/_lib/formatDistance/index": [
		84318,
		7,
		84318
	],
	"./de/_lib/formatDistance/index.js": [
		84318,
		7,
		84318
	],
	"./de/_lib/formatLong": [
		42568,
		7,
		42568
	],
	"./de/_lib/formatLong/": [
		42568,
		7,
		42568
	],
	"./de/_lib/formatLong/index": [
		42568,
		7,
		42568
	],
	"./de/_lib/formatLong/index.js": [
		42568,
		7,
		42568
	],
	"./de/_lib/formatRelative": [
		15252,
		7,
		15252
	],
	"./de/_lib/formatRelative/": [
		15252,
		7,
		15252
	],
	"./de/_lib/formatRelative/index": [
		15252,
		7,
		15252
	],
	"./de/_lib/formatRelative/index.js": [
		15252,
		7,
		15252
	],
	"./de/_lib/localize": [
		3810,
		7,
		3810
	],
	"./de/_lib/localize/": [
		3810,
		7,
		3810
	],
	"./de/_lib/localize/index": [
		3810,
		7,
		3810
	],
	"./de/_lib/localize/index.js": [
		3810,
		7,
		3810
	],
	"./de/_lib/match": [
		46984,
		7,
		46984
	],
	"./de/_lib/match/": [
		46984,
		7,
		46984
	],
	"./de/_lib/match/index": [
		46984,
		7,
		46984
	],
	"./de/_lib/match/index.js": [
		46984,
		7,
		46984
	],
	"./de/index": [
		28355,
		7,
		28355
	],
	"./de/index.d": [
		502,
		9,
		502
	],
	"./de/index.d.ts": [
		502,
		9,
		502
	],
	"./de/index.js": [
		28355,
		7,
		28355
	],
	"./de/index.js.flow": [
		50846,
		1,
		50846
	],
	"./de/package": [
		92603,
		3,
		92603
	],
	"./de/package.json": [
		92603,
		3,
		92603
	],
	"./el": [
		31928,
		9,
		31928
	],
	"./el/": [
		31928,
		9,
		31928
	],
	"./el/_lib/formatDistance": [
		30632,
		7,
		30632
	],
	"./el/_lib/formatDistance/": [
		30632,
		7,
		30632
	],
	"./el/_lib/formatDistance/index": [
		30632,
		7,
		30632
	],
	"./el/_lib/formatDistance/index.js": [
		30632,
		7,
		30632
	],
	"./el/_lib/formatLong": [
		97216,
		7,
		97216
	],
	"./el/_lib/formatLong/": [
		97216,
		7,
		97216
	],
	"./el/_lib/formatLong/index": [
		97216,
		7,
		97216
	],
	"./el/_lib/formatLong/index.js": [
		97216,
		7,
		97216
	],
	"./el/_lib/formatRelative": [
		45375,
		7,
		45375
	],
	"./el/_lib/formatRelative/": [
		45375,
		7,
		45375
	],
	"./el/_lib/formatRelative/index": [
		45375,
		7,
		45375
	],
	"./el/_lib/formatRelative/index.js": [
		45375,
		7,
		45375
	],
	"./el/_lib/localize": [
		12276,
		7,
		12276
	],
	"./el/_lib/localize/": [
		12276,
		7,
		12276
	],
	"./el/_lib/localize/index": [
		12276,
		7,
		12276
	],
	"./el/_lib/localize/index.js": [
		12276,
		7,
		12276
	],
	"./el/_lib/match": [
		83977,
		7,
		83977
	],
	"./el/_lib/match/": [
		83977,
		7,
		83977
	],
	"./el/_lib/match/index": [
		83977,
		7,
		83977
	],
	"./el/_lib/match/index.js": [
		83977,
		7,
		83977
	],
	"./el/index": [
		56556,
		7,
		56556
	],
	"./el/index.d": [
		80366,
		9,
		80366
	],
	"./el/index.d.ts": [
		80366,
		9,
		80366
	],
	"./el/index.js": [
		56556,
		7,
		56556
	],
	"./el/index.js.flow": [
		39555,
		1,
		39555
	],
	"./el/package": [
		77466,
		3,
		77466
	],
	"./el/package.json": [
		77466,
		3,
		77466
	],
	"./en-AU": [
		61386,
		9,
		61386
	],
	"./en-AU/": [
		61386,
		9,
		61386
	],
	"./en-AU/_lib/formatLong": [
		28158,
		7,
		28158
	],
	"./en-AU/_lib/formatLong/": [
		28158,
		7,
		28158
	],
	"./en-AU/_lib/formatLong/index": [
		28158,
		7,
		28158
	],
	"./en-AU/_lib/formatLong/index.js": [
		28158,
		7,
		28158
	],
	"./en-AU/index": [
		32353,
		7,
		32353
	],
	"./en-AU/index.d": [
		93786,
		9,
		93786
	],
	"./en-AU/index.d.ts": [
		93786,
		9,
		93786
	],
	"./en-AU/index.js": [
		32353,
		7,
		32353
	],
	"./en-AU/index.js.flow": [
		10359,
		1,
		10359
	],
	"./en-AU/package": [
		89507,
		3,
		89507
	],
	"./en-AU/package.json": [
		89507,
		3,
		89507
	],
	"./en-CA": [
		4762,
		9,
		4762
	],
	"./en-CA/": [
		4762,
		9,
		4762
	],
	"./en-CA/_lib/formatDistance": [
		89615,
		7,
		89615
	],
	"./en-CA/_lib/formatDistance/": [
		89615,
		7,
		89615
	],
	"./en-CA/_lib/formatDistance/index": [
		89615,
		7,
		89615
	],
	"./en-CA/_lib/formatDistance/index.js": [
		89615,
		7,
		89615
	],
	"./en-CA/_lib/formatLong": [
		63563,
		7,
		63563
	],
	"./en-CA/_lib/formatLong/": [
		63563,
		7,
		63563
	],
	"./en-CA/_lib/formatLong/index": [
		63563,
		7,
		63563
	],
	"./en-CA/_lib/formatLong/index.js": [
		63563,
		7,
		63563
	],
	"./en-CA/index": [
		54200,
		7,
		54200
	],
	"./en-CA/index.d": [
		90328,
		9,
		90328
	],
	"./en-CA/index.d.ts": [
		90328,
		9,
		90328
	],
	"./en-CA/index.js": [
		54200,
		7,
		54200
	],
	"./en-CA/index.js.flow": [
		46202,
		1,
		46202
	],
	"./en-CA/package": [
		94947,
		3,
		94947
	],
	"./en-CA/package.json": [
		94947,
		3,
		94947
	],
	"./en-GB": [
		92316,
		9,
		92316
	],
	"./en-GB/": [
		92316,
		9,
		92316
	],
	"./en-GB/_lib/formatLong": [
		51223,
		7,
		51223
	],
	"./en-GB/_lib/formatLong/": [
		51223,
		7,
		51223
	],
	"./en-GB/_lib/formatLong/index": [
		51223,
		7,
		51223
	],
	"./en-GB/_lib/formatLong/index.js": [
		51223,
		7,
		51223
	],
	"./en-GB/index": [
		51901,
		7,
		51901
	],
	"./en-GB/index.d": [
		33056,
		9,
		33056
	],
	"./en-GB/index.d.ts": [
		33056,
		9,
		33056
	],
	"./en-GB/index.js": [
		51901,
		7,
		51901
	],
	"./en-GB/index.js.flow": [
		33776,
		1,
		33776
	],
	"./en-GB/package": [
		92892,
		3,
		92892
	],
	"./en-GB/package.json": [
		92892,
		3,
		92892
	],
	"./en-IN": [
		60730,
		9,
		60730
	],
	"./en-IN/": [
		60730,
		9,
		60730
	],
	"./en-IN/_lib/formatLong": [
		85279,
		7,
		85279
	],
	"./en-IN/_lib/formatLong/": [
		85279,
		7,
		85279
	],
	"./en-IN/_lib/formatLong/index": [
		85279,
		7,
		85279
	],
	"./en-IN/_lib/formatLong/index.js": [
		85279,
		7,
		85279
	],
	"./en-IN/index": [
		53633,
		7,
		53633
	],
	"./en-IN/index.d": [
		58164,
		9,
		58164
	],
	"./en-IN/index.d.ts": [
		58164,
		9,
		58164
	],
	"./en-IN/index.js": [
		53633,
		7,
		53633
	],
	"./en-IN/index.js.flow": [
		25809,
		1,
		25809
	],
	"./en-IN/package": [
		69534,
		3,
		69534
	],
	"./en-IN/package.json": [
		69534,
		3,
		69534
	],
	"./en-NZ": [
		65754,
		9,
		65754
	],
	"./en-NZ/": [
		65754,
		9,
		65754
	],
	"./en-NZ/_lib/formatLong": [
		32736,
		7,
		32736
	],
	"./en-NZ/_lib/formatLong/": [
		32736,
		7,
		32736
	],
	"./en-NZ/_lib/formatLong/index": [
		32736,
		7,
		32736
	],
	"./en-NZ/_lib/formatLong/index.js": [
		32736,
		7,
		32736
	],
	"./en-NZ/index": [
		34882,
		7,
		34882
	],
	"./en-NZ/index.d": [
		58221,
		9,
		58221
	],
	"./en-NZ/index.d.ts": [
		58221,
		9,
		58221
	],
	"./en-NZ/index.js": [
		34882,
		7,
		34882
	],
	"./en-NZ/index.js.flow": [
		8192,
		1,
		8192
	],
	"./en-NZ/package": [
		49786,
		3,
		49786
	],
	"./en-NZ/package.json": [
		49786,
		3,
		49786
	],
	"./en-US": [
		776,
		9
	],
	"./en-US/": [
		776,
		9
	],
	"./en-US/_lib/formatDistance": [
		79654,
		7,
		79654
	],
	"./en-US/_lib/formatDistance/": [
		79654,
		7,
		79654
	],
	"./en-US/_lib/formatDistance/index": [
		79654,
		7,
		79654
	],
	"./en-US/_lib/formatDistance/index.js": [
		79654,
		7,
		79654
	],
	"./en-US/_lib/formatLong": [
		78552,
		7,
		78552
	],
	"./en-US/_lib/formatLong/": [
		78552,
		7,
		78552
	],
	"./en-US/_lib/formatLong/index": [
		78552,
		7,
		78552
	],
	"./en-US/_lib/formatLong/index.js": [
		78552,
		7,
		78552
	],
	"./en-US/_lib/formatRelative": [
		35687,
		7,
		35687
	],
	"./en-US/_lib/formatRelative/": [
		35687,
		7,
		35687
	],
	"./en-US/_lib/formatRelative/index": [
		35687,
		7,
		35687
	],
	"./en-US/_lib/formatRelative/index.js": [
		35687,
		7,
		35687
	],
	"./en-US/_lib/localize": [
		9224,
		7,
		9224
	],
	"./en-US/_lib/localize/": [
		9224,
		7,
		9224
	],
	"./en-US/_lib/localize/index": [
		9224,
		7,
		9224
	],
	"./en-US/_lib/localize/index.js": [
		9224,
		7,
		9224
	],
	"./en-US/_lib/match": [
		1540,
		7,
		1540
	],
	"./en-US/_lib/match/": [
		1540,
		7,
		1540
	],
	"./en-US/_lib/match/index": [
		1540,
		7,
		1540
	],
	"./en-US/_lib/match/index.js": [
		1540,
		7,
		1540
	],
	"./en-US/index": [
		8035,
		7,
		8035
	],
	"./en-US/index.d": [
		76812,
		9,
		76812
	],
	"./en-US/index.d.ts": [
		76812,
		9,
		76812
	],
	"./en-US/index.js": [
		8035,
		7,
		8035
	],
	"./en-US/index.js.flow": [
		93857,
		1,
		93857
	],
	"./en-US/package": [
		98702,
		3,
		98702
	],
	"./en-US/package.json": [
		98702,
		3,
		98702
	],
	"./en-ZA": [
		33831,
		9,
		33831
	],
	"./en-ZA/": [
		33831,
		9,
		33831
	],
	"./en-ZA/_lib/formatLong": [
		77976,
		7,
		77976
	],
	"./en-ZA/_lib/formatLong/": [
		77976,
		7,
		77976
	],
	"./en-ZA/_lib/formatLong/index": [
		77976,
		7,
		77976
	],
	"./en-ZA/_lib/formatLong/index.js": [
		77976,
		7,
		77976
	],
	"./en-ZA/index": [
		11304,
		7,
		11304
	],
	"./en-ZA/index.d": [
		92948,
		9,
		92948
	],
	"./en-ZA/index.d.ts": [
		92948,
		9,
		92948
	],
	"./en-ZA/index.js": [
		11304,
		7,
		11304
	],
	"./en-ZA/index.js.flow": [
		62212,
		1,
		62212
	],
	"./en-ZA/package": [
		76794,
		3,
		76794
	],
	"./en-ZA/package.json": [
		76794,
		3,
		76794
	],
	"./eo": [
		19687,
		9,
		19687
	],
	"./eo/": [
		19687,
		9,
		19687
	],
	"./eo/_lib/formatDistance": [
		86775,
		7,
		86775
	],
	"./eo/_lib/formatDistance/": [
		86775,
		7,
		86775
	],
	"./eo/_lib/formatDistance/index": [
		86775,
		7,
		86775
	],
	"./eo/_lib/formatDistance/index.js": [
		86775,
		7,
		86775
	],
	"./eo/_lib/formatLong": [
		94489,
		7,
		94489
	],
	"./eo/_lib/formatLong/": [
		94489,
		7,
		94489
	],
	"./eo/_lib/formatLong/index": [
		94489,
		7,
		94489
	],
	"./eo/_lib/formatLong/index.js": [
		94489,
		7,
		94489
	],
	"./eo/_lib/formatRelative": [
		91063,
		7,
		91063
	],
	"./eo/_lib/formatRelative/": [
		91063,
		7,
		91063
	],
	"./eo/_lib/formatRelative/index": [
		91063,
		7,
		91063
	],
	"./eo/_lib/formatRelative/index.js": [
		91063,
		7,
		91063
	],
	"./eo/_lib/localize": [
		73801,
		7,
		73801
	],
	"./eo/_lib/localize/": [
		73801,
		7,
		73801
	],
	"./eo/_lib/localize/index": [
		73801,
		7,
		73801
	],
	"./eo/_lib/localize/index.js": [
		73801,
		7,
		73801
	],
	"./eo/_lib/match": [
		85138,
		7,
		85138
	],
	"./eo/_lib/match/": [
		85138,
		7,
		85138
	],
	"./eo/_lib/match/index": [
		85138,
		7,
		85138
	],
	"./eo/_lib/match/index.js": [
		85138,
		7,
		85138
	],
	"./eo/index": [
		96994,
		7,
		96994
	],
	"./eo/index.d": [
		83895,
		9,
		83895
	],
	"./eo/index.d.ts": [
		83895,
		9,
		83895
	],
	"./eo/index.js": [
		96994,
		7,
		96994
	],
	"./eo/index.js.flow": [
		22274,
		1,
		22274
	],
	"./eo/package": [
		11501,
		3,
		11501
	],
	"./eo/package.json": [
		11501,
		3,
		11501
	],
	"./es": [
		4990,
		9,
		4990
	],
	"./es/": [
		4990,
		9,
		4990
	],
	"./es/_lib/formatDistance": [
		59955,
		7,
		59955
	],
	"./es/_lib/formatDistance/": [
		59955,
		7,
		59955
	],
	"./es/_lib/formatDistance/index": [
		59955,
		7,
		59955
	],
	"./es/_lib/formatDistance/index.js": [
		59955,
		7,
		59955
	],
	"./es/_lib/formatLong": [
		98984,
		7,
		98984
	],
	"./es/_lib/formatLong/": [
		98984,
		7,
		98984
	],
	"./es/_lib/formatLong/index": [
		98984,
		7,
		98984
	],
	"./es/_lib/formatLong/index.js": [
		98984,
		7,
		98984
	],
	"./es/_lib/formatRelative": [
		43974,
		7,
		43974
	],
	"./es/_lib/formatRelative/": [
		43974,
		7,
		43974
	],
	"./es/_lib/formatRelative/index": [
		43974,
		7,
		43974
	],
	"./es/_lib/formatRelative/index.js": [
		43974,
		7,
		43974
	],
	"./es/_lib/localize": [
		58956,
		7,
		58956
	],
	"./es/_lib/localize/": [
		58956,
		7,
		58956
	],
	"./es/_lib/localize/index": [
		58956,
		7,
		58956
	],
	"./es/_lib/localize/index.js": [
		58956,
		7,
		58956
	],
	"./es/_lib/match": [
		58624,
		7,
		58624
	],
	"./es/_lib/match/": [
		58624,
		7,
		58624
	],
	"./es/_lib/match/index": [
		58624,
		7,
		58624
	],
	"./es/_lib/match/index.js": [
		58624,
		7,
		58624
	],
	"./es/index": [
		45224,
		7,
		45224
	],
	"./es/index.d": [
		58041,
		9,
		58041
	],
	"./es/index.d.ts": [
		58041,
		9,
		58041
	],
	"./es/index.js": [
		45224,
		7,
		45224
	],
	"./es/index.js.flow": [
		82838,
		1,
		82838
	],
	"./es/package": [
		14343,
		3,
		14343
	],
	"./es/package.json": [
		14343,
		3,
		14343
	],
	"./et": [
		47398,
		9,
		47398
	],
	"./et/": [
		47398,
		9,
		47398
	],
	"./et/_lib/formatDistance": [
		32960,
		7,
		32960
	],
	"./et/_lib/formatDistance/": [
		32960,
		7,
		32960
	],
	"./et/_lib/formatDistance/index": [
		32960,
		7,
		32960
	],
	"./et/_lib/formatDistance/index.js": [
		32960,
		7,
		32960
	],
	"./et/_lib/formatLong": [
		44469,
		7,
		44469
	],
	"./et/_lib/formatLong/": [
		44469,
		7,
		44469
	],
	"./et/_lib/formatLong/index": [
		44469,
		7,
		44469
	],
	"./et/_lib/formatLong/index.js": [
		44469,
		7,
		44469
	],
	"./et/_lib/formatRelative": [
		61998,
		7,
		61998
	],
	"./et/_lib/formatRelative/": [
		61998,
		7,
		61998
	],
	"./et/_lib/formatRelative/index": [
		61998,
		7,
		61998
	],
	"./et/_lib/formatRelative/index.js": [
		61998,
		7,
		61998
	],
	"./et/_lib/localize": [
		68338,
		7,
		68338
	],
	"./et/_lib/localize/": [
		68338,
		7,
		68338
	],
	"./et/_lib/localize/index": [
		68338,
		7,
		68338
	],
	"./et/_lib/localize/index.js": [
		68338,
		7,
		68338
	],
	"./et/_lib/match": [
		61314,
		7,
		61314
	],
	"./et/_lib/match/": [
		61314,
		7,
		61314
	],
	"./et/_lib/match/index": [
		61314,
		7,
		61314
	],
	"./et/_lib/match/index.js": [
		61314,
		7,
		61314
	],
	"./et/index": [
		4200,
		7,
		4200
	],
	"./et/index.d": [
		3402,
		9,
		3402
	],
	"./et/index.d.ts": [
		3402,
		9,
		3402
	],
	"./et/index.js": [
		4200,
		7,
		4200
	],
	"./et/index.js.flow": [
		79183,
		1,
		79183
	],
	"./et/package": [
		62359,
		3,
		62359
	],
	"./et/package.json": [
		62359,
		3,
		62359
	],
	"./eu": [
		85014,
		9,
		85014
	],
	"./eu/": [
		85014,
		9,
		85014
	],
	"./eu/_lib/formatDistance": [
		3537,
		7,
		3537
	],
	"./eu/_lib/formatDistance/": [
		3537,
		7,
		3537
	],
	"./eu/_lib/formatDistance/index": [
		3537,
		7,
		3537
	],
	"./eu/_lib/formatDistance/index.js": [
		3537,
		7,
		3537
	],
	"./eu/_lib/formatLong": [
		79263,
		7,
		79263
	],
	"./eu/_lib/formatLong/": [
		79263,
		7,
		79263
	],
	"./eu/_lib/formatLong/index": [
		79263,
		7,
		79263
	],
	"./eu/_lib/formatLong/index.js": [
		79263,
		7,
		79263
	],
	"./eu/_lib/formatRelative": [
		77123,
		7,
		77123
	],
	"./eu/_lib/formatRelative/": [
		77123,
		7,
		77123
	],
	"./eu/_lib/formatRelative/index": [
		77123,
		7,
		77123
	],
	"./eu/_lib/formatRelative/index.js": [
		77123,
		7,
		77123
	],
	"./eu/_lib/localize": [
		92934,
		7,
		92934
	],
	"./eu/_lib/localize/": [
		92934,
		7,
		92934
	],
	"./eu/_lib/localize/index": [
		92934,
		7,
		92934
	],
	"./eu/_lib/localize/index.js": [
		92934,
		7,
		92934
	],
	"./eu/_lib/match": [
		32409,
		7,
		32409
	],
	"./eu/_lib/match/": [
		32409,
		7,
		32409
	],
	"./eu/_lib/match/index": [
		32409,
		7,
		32409
	],
	"./eu/_lib/match/index.js": [
		32409,
		7,
		32409
	],
	"./eu/index": [
		30750,
		7,
		30750
	],
	"./eu/index.d": [
		16135,
		9,
		16135
	],
	"./eu/index.d.ts": [
		16135,
		9,
		16135
	],
	"./eu/index.js": [
		30750,
		7,
		30750
	],
	"./eu/index.js.flow": [
		63377,
		1,
		63377
	],
	"./eu/package": [
		56960,
		3,
		56960
	],
	"./eu/package.json": [
		56960,
		3,
		56960
	],
	"./fa-IR": [
		88197,
		9,
		88197
	],
	"./fa-IR/": [
		88197,
		9,
		88197
	],
	"./fa-IR/_lib/formatDistance": [
		5652,
		7,
		5652
	],
	"./fa-IR/_lib/formatDistance/": [
		5652,
		7,
		5652
	],
	"./fa-IR/_lib/formatDistance/index": [
		5652,
		7,
		5652
	],
	"./fa-IR/_lib/formatDistance/index.js": [
		5652,
		7,
		5652
	],
	"./fa-IR/_lib/formatLong": [
		86522,
		7,
		86522
	],
	"./fa-IR/_lib/formatLong/": [
		86522,
		7,
		86522
	],
	"./fa-IR/_lib/formatLong/index": [
		86522,
		7,
		86522
	],
	"./fa-IR/_lib/formatLong/index.js": [
		86522,
		7,
		86522
	],
	"./fa-IR/_lib/formatRelative": [
		59375,
		7,
		59375
	],
	"./fa-IR/_lib/formatRelative/": [
		59375,
		7,
		59375
	],
	"./fa-IR/_lib/formatRelative/index": [
		59375,
		7,
		59375
	],
	"./fa-IR/_lib/formatRelative/index.js": [
		59375,
		7,
		59375
	],
	"./fa-IR/_lib/localize": [
		5714,
		7,
		5714
	],
	"./fa-IR/_lib/localize/": [
		5714,
		7,
		5714
	],
	"./fa-IR/_lib/localize/index": [
		5714,
		7,
		5714
	],
	"./fa-IR/_lib/localize/index.js": [
		5714,
		7,
		5714
	],
	"./fa-IR/_lib/match": [
		72769,
		7,
		72769
	],
	"./fa-IR/_lib/match/": [
		72769,
		7,
		72769
	],
	"./fa-IR/_lib/match/index": [
		72769,
		7,
		72769
	],
	"./fa-IR/_lib/match/index.js": [
		72769,
		7,
		72769
	],
	"./fa-IR/index": [
		74327,
		7,
		74327
	],
	"./fa-IR/index.d": [
		7319,
		9,
		7319
	],
	"./fa-IR/index.d.ts": [
		7319,
		9,
		7319
	],
	"./fa-IR/index.js": [
		74327,
		7,
		74327
	],
	"./fa-IR/index.js.flow": [
		11705,
		1,
		11705
	],
	"./fa-IR/package": [
		57101,
		3,
		57101
	],
	"./fa-IR/package.json": [
		57101,
		3,
		57101
	],
	"./fi": [
		86675,
		9,
		86675
	],
	"./fi/": [
		86675,
		9,
		86675
	],
	"./fi/_lib/formatDistance": [
		35923,
		7,
		35923
	],
	"./fi/_lib/formatDistance/": [
		35923,
		7,
		35923
	],
	"./fi/_lib/formatDistance/index": [
		35923,
		7,
		35923
	],
	"./fi/_lib/formatDistance/index.js": [
		35923,
		7,
		35923
	],
	"./fi/_lib/formatLong": [
		40280,
		7,
		40280
	],
	"./fi/_lib/formatLong/": [
		40280,
		7,
		40280
	],
	"./fi/_lib/formatLong/index": [
		40280,
		7,
		40280
	],
	"./fi/_lib/formatLong/index.js": [
		40280,
		7,
		40280
	],
	"./fi/_lib/formatRelative": [
		55767,
		7,
		55767
	],
	"./fi/_lib/formatRelative/": [
		55767,
		7,
		55767
	],
	"./fi/_lib/formatRelative/index": [
		55767,
		7,
		55767
	],
	"./fi/_lib/formatRelative/index.js": [
		55767,
		7,
		55767
	],
	"./fi/_lib/localize": [
		77328,
		7,
		77328
	],
	"./fi/_lib/localize/": [
		77328,
		7,
		77328
	],
	"./fi/_lib/localize/index": [
		77328,
		7,
		77328
	],
	"./fi/_lib/localize/index.js": [
		77328,
		7,
		77328
	],
	"./fi/_lib/match": [
		95660,
		7,
		95660
	],
	"./fi/_lib/match/": [
		95660,
		7,
		95660
	],
	"./fi/_lib/match/index": [
		95660,
		7,
		95660
	],
	"./fi/_lib/match/index.js": [
		95660,
		7,
		95660
	],
	"./fi/index": [
		98664,
		7,
		98664
	],
	"./fi/index.d": [
		2330,
		9,
		2330
	],
	"./fi/index.d.ts": [
		2330,
		9,
		2330
	],
	"./fi/index.js": [
		98664,
		7,
		98664
	],
	"./fi/index.js.flow": [
		48633,
		1,
		48633
	],
	"./fi/package": [
		82986,
		3,
		82986
	],
	"./fi/package.json": [
		82986,
		3,
		82986
	],
	"./fr": [
		96911,
		9,
		96911
	],
	"./fr-CA": [
		48379,
		9,
		48379
	],
	"./fr-CA/": [
		48379,
		9,
		48379
	],
	"./fr-CA/_lib/formatLong": [
		86099,
		7,
		86099
	],
	"./fr-CA/_lib/formatLong/": [
		86099,
		7,
		86099
	],
	"./fr-CA/_lib/formatLong/index": [
		86099,
		7,
		86099
	],
	"./fr-CA/_lib/formatLong/index.js": [
		86099,
		7,
		86099
	],
	"./fr-CA/index": [
		24166,
		7,
		24166
	],
	"./fr-CA/index.d": [
		60181,
		9,
		60181
	],
	"./fr-CA/index.d.ts": [
		60181,
		9,
		60181
	],
	"./fr-CA/index.js": [
		24166,
		7,
		24166
	],
	"./fr-CA/index.js.flow": [
		57775,
		1,
		57775
	],
	"./fr-CA/package": [
		40752,
		3,
		40752
	],
	"./fr-CA/package.json": [
		40752,
		3,
		40752
	],
	"./fr-CH": [
		99813,
		9,
		99813
	],
	"./fr-CH/": [
		99813,
		9,
		99813
	],
	"./fr-CH/_lib/formatDistance": [
		97914,
		7,
		97914
	],
	"./fr-CH/_lib/formatDistance/": [
		97914,
		7,
		97914
	],
	"./fr-CH/_lib/formatDistance/index": [
		97914,
		7,
		97914
	],
	"./fr-CH/_lib/formatDistance/index.js": [
		97914,
		7,
		97914
	],
	"./fr-CH/_lib/formatLong": [
		23964,
		7,
		23964
	],
	"./fr-CH/_lib/formatLong/": [
		23964,
		7,
		23964
	],
	"./fr-CH/_lib/formatLong/index": [
		23964,
		7,
		23964
	],
	"./fr-CH/_lib/formatLong/index.js": [
		23964,
		7,
		23964
	],
	"./fr-CH/_lib/formatRelative": [
		28945,
		7,
		28945
	],
	"./fr-CH/_lib/formatRelative/": [
		28945,
		7,
		28945
	],
	"./fr-CH/_lib/formatRelative/index": [
		28945,
		7,
		28945
	],
	"./fr-CH/_lib/formatRelative/index.js": [
		28945,
		7,
		28945
	],
	"./fr-CH/_lib/formatters": [
		37951,
		7,
		37951
	],
	"./fr-CH/_lib/formatters/": [
		37951,
		7,
		37951
	],
	"./fr-CH/_lib/formatters/index": [
		37951,
		7,
		37951
	],
	"./fr-CH/_lib/formatters/index.js": [
		37951,
		7,
		37951
	],
	"./fr-CH/_lib/localize": [
		2909,
		7,
		2909
	],
	"./fr-CH/_lib/localize/": [
		2909,
		7,
		2909
	],
	"./fr-CH/_lib/localize/index": [
		2909,
		7,
		2909
	],
	"./fr-CH/_lib/localize/index.js": [
		2909,
		7,
		2909
	],
	"./fr-CH/_lib/match": [
		51245,
		7,
		51245
	],
	"./fr-CH/_lib/match/": [
		51245,
		7,
		51245
	],
	"./fr-CH/_lib/match/index": [
		51245,
		7,
		51245
	],
	"./fr-CH/_lib/match/index.js": [
		51245,
		7,
		51245
	],
	"./fr-CH/index": [
		94692,
		7,
		94692
	],
	"./fr-CH/index.d": [
		80667,
		9,
		80667
	],
	"./fr-CH/index.d.ts": [
		80667,
		9,
		80667
	],
	"./fr-CH/index.js": [
		94692,
		7,
		94692
	],
	"./fr-CH/index.js.flow": [
		79101,
		1,
		79101
	],
	"./fr-CH/package": [
		16369,
		3,
		16369
	],
	"./fr-CH/package.json": [
		16369,
		3,
		16369
	],
	"./fr/": [
		96911,
		9,
		96911
	],
	"./fr/_lib/formatDistance": [
		31905,
		7,
		31905
	],
	"./fr/_lib/formatDistance/": [
		31905,
		7,
		31905
	],
	"./fr/_lib/formatDistance/index": [
		31905,
		7,
		31905
	],
	"./fr/_lib/formatDistance/index.js": [
		31905,
		7,
		31905
	],
	"./fr/_lib/formatLong": [
		91619,
		7,
		91619
	],
	"./fr/_lib/formatLong/": [
		91619,
		7,
		91619
	],
	"./fr/_lib/formatLong/index": [
		91619,
		7,
		91619
	],
	"./fr/_lib/formatLong/index.js": [
		91619,
		7,
		91619
	],
	"./fr/_lib/formatRelative": [
		84382,
		7,
		84382
	],
	"./fr/_lib/formatRelative/": [
		84382,
		7,
		84382
	],
	"./fr/_lib/formatRelative/index": [
		84382,
		7,
		84382
	],
	"./fr/_lib/formatRelative/index.js": [
		84382,
		7,
		84382
	],
	"./fr/_lib/formatters": [
		54594,
		7,
		54594
	],
	"./fr/_lib/formatters/": [
		54594,
		7,
		54594
	],
	"./fr/_lib/formatters/index": [
		54594,
		7,
		54594
	],
	"./fr/_lib/formatters/index.js": [
		54594,
		7,
		54594
	],
	"./fr/_lib/localize": [
		14392,
		7,
		14392
	],
	"./fr/_lib/localize/": [
		14392,
		7,
		14392
	],
	"./fr/_lib/localize/index": [
		14392,
		7,
		14392
	],
	"./fr/_lib/localize/index.js": [
		14392,
		7,
		14392
	],
	"./fr/_lib/match": [
		5021,
		7,
		5021
	],
	"./fr/_lib/match/": [
		5021,
		7,
		5021
	],
	"./fr/_lib/match/index": [
		5021,
		7,
		5021
	],
	"./fr/_lib/match/index.js": [
		5021,
		7,
		5021
	],
	"./fr/index": [
		60049,
		7,
		60049
	],
	"./fr/index.d": [
		7684,
		9,
		7684
	],
	"./fr/index.d.ts": [
		7684,
		9,
		7684
	],
	"./fr/index.js": [
		60049,
		7,
		60049
	],
	"./fr/index.js.flow": [
		57461,
		1,
		57461
	],
	"./fr/package": [
		93077,
		3,
		93077
	],
	"./fr/package.json": [
		93077,
		3,
		93077
	],
	"./gd": [
		45289,
		9,
		45289
	],
	"./gd/": [
		45289,
		9,
		45289
	],
	"./gd/_lib/formatDistance": [
		97780,
		7,
		97780
	],
	"./gd/_lib/formatDistance/": [
		97780,
		7,
		97780
	],
	"./gd/_lib/formatDistance/index": [
		97780,
		7,
		97780
	],
	"./gd/_lib/formatDistance/index.js": [
		97780,
		7,
		97780
	],
	"./gd/_lib/formatLong": [
		86839,
		7,
		86839
	],
	"./gd/_lib/formatLong/": [
		86839,
		7,
		86839
	],
	"./gd/_lib/formatLong/index": [
		86839,
		7,
		86839
	],
	"./gd/_lib/formatLong/index.js": [
		86839,
		7,
		86839
	],
	"./gd/_lib/formatRelative": [
		1762,
		7,
		1762
	],
	"./gd/_lib/formatRelative/": [
		1762,
		7,
		1762
	],
	"./gd/_lib/formatRelative/index": [
		1762,
		7,
		1762
	],
	"./gd/_lib/formatRelative/index.js": [
		1762,
		7,
		1762
	],
	"./gd/_lib/localize": [
		14106,
		7,
		14106
	],
	"./gd/_lib/localize/": [
		14106,
		7,
		14106
	],
	"./gd/_lib/localize/index": [
		14106,
		7,
		14106
	],
	"./gd/_lib/localize/index.js": [
		14106,
		7,
		14106
	],
	"./gd/_lib/match": [
		46326,
		7,
		46326
	],
	"./gd/_lib/match/": [
		46326,
		7,
		46326
	],
	"./gd/_lib/match/index": [
		46326,
		7,
		46326
	],
	"./gd/_lib/match/index.js": [
		46326,
		7,
		46326
	],
	"./gd/index": [
		4242,
		7,
		4242
	],
	"./gd/index.d": [
		27458,
		9,
		27458
	],
	"./gd/index.d.ts": [
		27458,
		9,
		27458
	],
	"./gd/index.js": [
		4242,
		7,
		4242
	],
	"./gd/index.js.flow": [
		64702,
		1,
		64702
	],
	"./gd/package": [
		40096,
		3,
		40096
	],
	"./gd/package.json": [
		40096,
		3,
		40096
	],
	"./gl": [
		44354,
		9,
		44354
	],
	"./gl/": [
		44354,
		9,
		44354
	],
	"./gl/_lib/formatDistance": [
		19240,
		7,
		19240
	],
	"./gl/_lib/formatDistance/": [
		19240,
		7,
		19240
	],
	"./gl/_lib/formatDistance/index": [
		19240,
		7,
		19240
	],
	"./gl/_lib/formatDistance/index.js": [
		19240,
		7,
		19240
	],
	"./gl/_lib/formatLong": [
		78534,
		7,
		78534
	],
	"./gl/_lib/formatLong/": [
		78534,
		7,
		78534
	],
	"./gl/_lib/formatLong/index": [
		78534,
		7,
		78534
	],
	"./gl/_lib/formatLong/index.js": [
		78534,
		7,
		78534
	],
	"./gl/_lib/formatRelative": [
		44693,
		7,
		44693
	],
	"./gl/_lib/formatRelative/": [
		44693,
		7,
		44693
	],
	"./gl/_lib/formatRelative/index": [
		44693,
		7,
		44693
	],
	"./gl/_lib/formatRelative/index.js": [
		44693,
		7,
		44693
	],
	"./gl/_lib/localize": [
		89165,
		7,
		89165
	],
	"./gl/_lib/localize/": [
		89165,
		7,
		89165
	],
	"./gl/_lib/localize/index": [
		89165,
		7,
		89165
	],
	"./gl/_lib/localize/index.js": [
		89165,
		7,
		89165
	],
	"./gl/_lib/match": [
		37515,
		7,
		96080
	],
	"./gl/_lib/match/": [
		37515,
		7,
		96080
	],
	"./gl/_lib/match/index": [
		37515,
		7,
		96080
	],
	"./gl/_lib/match/index.js": [
		37515,
		7,
		96080
	],
	"./gl/index": [
		49732,
		7,
		49732
	],
	"./gl/index.d": [
		64573,
		9,
		64573
	],
	"./gl/index.d.ts": [
		64573,
		9,
		64573
	],
	"./gl/index.js": [
		49732,
		7,
		49732
	],
	"./gl/index.js.flow": [
		31327,
		1,
		31327
	],
	"./gl/package": [
		59557,
		3,
		59557
	],
	"./gl/package.json": [
		59557,
		3,
		59557
	],
	"./gu": [
		42777,
		9,
		42777
	],
	"./gu/": [
		42777,
		9,
		42777
	],
	"./gu/_lib/formatDistance": [
		35445,
		7,
		35445
	],
	"./gu/_lib/formatDistance/": [
		35445,
		7,
		35445
	],
	"./gu/_lib/formatDistance/index": [
		35445,
		7,
		35445
	],
	"./gu/_lib/formatDistance/index.js": [
		35445,
		7,
		35445
	],
	"./gu/_lib/formatLong": [
		77422,
		7,
		77422
	],
	"./gu/_lib/formatLong/": [
		77422,
		7,
		77422
	],
	"./gu/_lib/formatLong/index": [
		77422,
		7,
		77422
	],
	"./gu/_lib/formatLong/index.js": [
		77422,
		7,
		77422
	],
	"./gu/_lib/formatRelative": [
		18710,
		7,
		18710
	],
	"./gu/_lib/formatRelative/": [
		18710,
		7,
		18710
	],
	"./gu/_lib/formatRelative/index": [
		18710,
		7,
		18710
	],
	"./gu/_lib/formatRelative/index.js": [
		18710,
		7,
		18710
	],
	"./gu/_lib/localize": [
		40298,
		7,
		40298
	],
	"./gu/_lib/localize/": [
		40298,
		7,
		40298
	],
	"./gu/_lib/localize/index": [
		40298,
		7,
		40298
	],
	"./gu/_lib/localize/index.js": [
		40298,
		7,
		40298
	],
	"./gu/_lib/match": [
		79419,
		7,
		79419
	],
	"./gu/_lib/match/": [
		79419,
		7,
		79419
	],
	"./gu/_lib/match/index": [
		79419,
		7,
		79419
	],
	"./gu/_lib/match/index.js": [
		79419,
		7,
		79419
	],
	"./gu/index": [
		22404,
		7,
		22404
	],
	"./gu/index.d": [
		48541,
		9,
		48541
	],
	"./gu/index.d.ts": [
		48541,
		9,
		48541
	],
	"./gu/index.js": [
		22404,
		7,
		22404
	],
	"./gu/index.js.flow": [
		20263,
		1,
		20263
	],
	"./gu/package": [
		58277,
		3,
		58277
	],
	"./gu/package.json": [
		58277,
		3,
		58277
	],
	"./he": [
		63477,
		9,
		63477
	],
	"./he/": [
		63477,
		9,
		63477
	],
	"./he/_lib/formatDistance": [
		37506,
		7,
		37506
	],
	"./he/_lib/formatDistance/": [
		37506,
		7,
		37506
	],
	"./he/_lib/formatDistance/index": [
		37506,
		7,
		37506
	],
	"./he/_lib/formatDistance/index.js": [
		37506,
		7,
		37506
	],
	"./he/_lib/formatLong": [
		76391,
		7,
		76391
	],
	"./he/_lib/formatLong/": [
		76391,
		7,
		76391
	],
	"./he/_lib/formatLong/index": [
		76391,
		7,
		76391
	],
	"./he/_lib/formatLong/index.js": [
		76391,
		7,
		76391
	],
	"./he/_lib/formatRelative": [
		61598,
		7,
		61598
	],
	"./he/_lib/formatRelative/": [
		61598,
		7,
		61598
	],
	"./he/_lib/formatRelative/index": [
		61598,
		7,
		61598
	],
	"./he/_lib/formatRelative/index.js": [
		61598,
		7,
		61598
	],
	"./he/_lib/localize": [
		24241,
		7,
		24241
	],
	"./he/_lib/localize/": [
		24241,
		7,
		24241
	],
	"./he/_lib/localize/index": [
		24241,
		7,
		24241
	],
	"./he/_lib/localize/index.js": [
		24241,
		7,
		24241
	],
	"./he/_lib/match": [
		74470,
		7,
		74470
	],
	"./he/_lib/match/": [
		74470,
		7,
		74470
	],
	"./he/_lib/match/index": [
		74470,
		7,
		74470
	],
	"./he/_lib/match/index.js": [
		74470,
		7,
		74470
	],
	"./he/index": [
		46136,
		7,
		46136
	],
	"./he/index.d": [
		86850,
		9,
		86850
	],
	"./he/index.d.ts": [
		86850,
		9,
		86850
	],
	"./he/index.js": [
		46136,
		7,
		46136
	],
	"./he/index.js.flow": [
		65109,
		1,
		66462
	],
	"./he/package": [
		87453,
		3,
		87453
	],
	"./he/package.json": [
		87453,
		3,
		87453
	],
	"./hi": [
		70561,
		9,
		70561
	],
	"./hi/": [
		70561,
		9,
		70561
	],
	"./hi/_lib/formatDistance": [
		23452,
		7,
		23452
	],
	"./hi/_lib/formatDistance/": [
		23452,
		7,
		23452
	],
	"./hi/_lib/formatDistance/index": [
		23452,
		7,
		23452
	],
	"./hi/_lib/formatDistance/index.js": [
		23452,
		7,
		23452
	],
	"./hi/_lib/formatLong": [
		31806,
		7,
		31806
	],
	"./hi/_lib/formatLong/": [
		31806,
		7,
		31806
	],
	"./hi/_lib/formatLong/index": [
		31806,
		7,
		31806
	],
	"./hi/_lib/formatLong/index.js": [
		31806,
		7,
		31806
	],
	"./hi/_lib/formatRelative": [
		87837,
		7,
		87837
	],
	"./hi/_lib/formatRelative/": [
		87837,
		7,
		87837
	],
	"./hi/_lib/formatRelative/index": [
		87837,
		7,
		87837
	],
	"./hi/_lib/formatRelative/index.js": [
		87837,
		7,
		87837
	],
	"./hi/_lib/localize": [
		19575,
		7,
		19575
	],
	"./hi/_lib/localize/": [
		19575,
		7,
		19575
	],
	"./hi/_lib/localize/index": [
		19575,
		7,
		19575
	],
	"./hi/_lib/localize/index.js": [
		19575,
		7,
		19575
	],
	"./hi/_lib/match": [
		61888,
		7,
		61888
	],
	"./hi/_lib/match/": [
		61888,
		7,
		61888
	],
	"./hi/_lib/match/index": [
		61888,
		7,
		61888
	],
	"./hi/_lib/match/index.js": [
		61888,
		7,
		61888
	],
	"./hi/index": [
		27793,
		7,
		27793
	],
	"./hi/index.d": [
		26698,
		9,
		26698
	],
	"./hi/index.d.ts": [
		26698,
		9,
		26698
	],
	"./hi/index.js": [
		27793,
		7,
		27793
	],
	"./hi/index.js.flow": [
		35134,
		1,
		35134
	],
	"./hi/package": [
		89690,
		3,
		89690
	],
	"./hi/package.json": [
		89690,
		3,
		89690
	],
	"./hr": [
		3353,
		9,
		3353
	],
	"./hr/": [
		3353,
		9,
		3353
	],
	"./hr/_lib/formatDistance": [
		60037,
		7,
		60037
	],
	"./hr/_lib/formatDistance/": [
		60037,
		7,
		60037
	],
	"./hr/_lib/formatDistance/index": [
		60037,
		7,
		60037
	],
	"./hr/_lib/formatDistance/index.js": [
		60037,
		7,
		60037
	],
	"./hr/_lib/formatLong": [
		18949,
		7,
		18949
	],
	"./hr/_lib/formatLong/": [
		18949,
		7,
		18949
	],
	"./hr/_lib/formatLong/index": [
		18949,
		7,
		18949
	],
	"./hr/_lib/formatLong/index.js": [
		18949,
		7,
		18949
	],
	"./hr/_lib/formatRelative": [
		10007,
		7,
		10007
	],
	"./hr/_lib/formatRelative/": [
		10007,
		7,
		10007
	],
	"./hr/_lib/formatRelative/index": [
		10007,
		7,
		10007
	],
	"./hr/_lib/formatRelative/index.js": [
		10007,
		7,
		10007
	],
	"./hr/_lib/localize": [
		99729,
		7,
		99729
	],
	"./hr/_lib/localize/": [
		99729,
		7,
		99729
	],
	"./hr/_lib/localize/index": [
		99729,
		7,
		99729
	],
	"./hr/_lib/localize/index.js": [
		99729,
		7,
		99729
	],
	"./hr/_lib/match": [
		34892,
		7,
		34892
	],
	"./hr/_lib/match/": [
		34892,
		7,
		34892
	],
	"./hr/_lib/match/index": [
		34892,
		7,
		34892
	],
	"./hr/_lib/match/index.js": [
		34892,
		7,
		34892
	],
	"./hr/index": [
		47682,
		7,
		47682
	],
	"./hr/index.d": [
		98395,
		9,
		98395
	],
	"./hr/index.d.ts": [
		98395,
		9,
		98395
	],
	"./hr/index.js": [
		47682,
		7,
		47682
	],
	"./hr/index.js.flow": [
		81983,
		1,
		81983
	],
	"./hr/package": [
		48843,
		3,
		48843
	],
	"./hr/package.json": [
		48843,
		3,
		48843
	],
	"./hu": [
		346,
		9,
		346
	],
	"./hu/": [
		346,
		9,
		346
	],
	"./hu/_lib/formatDistance": [
		62757,
		7,
		62757
	],
	"./hu/_lib/formatDistance/": [
		62757,
		7,
		62757
	],
	"./hu/_lib/formatDistance/index": [
		62757,
		7,
		62757
	],
	"./hu/_lib/formatDistance/index.js": [
		62757,
		7,
		62757
	],
	"./hu/_lib/formatLong": [
		96179,
		7,
		96179
	],
	"./hu/_lib/formatLong/": [
		96179,
		7,
		96179
	],
	"./hu/_lib/formatLong/index": [
		96179,
		7,
		96179
	],
	"./hu/_lib/formatLong/index.js": [
		96179,
		7,
		96179
	],
	"./hu/_lib/formatRelative": [
		75286,
		7,
		75286
	],
	"./hu/_lib/formatRelative/": [
		75286,
		7,
		75286
	],
	"./hu/_lib/formatRelative/index": [
		75286,
		7,
		75286
	],
	"./hu/_lib/formatRelative/index.js": [
		75286,
		7,
		75286
	],
	"./hu/_lib/localize": [
		19394,
		7,
		19394
	],
	"./hu/_lib/localize/": [
		19394,
		7,
		19394
	],
	"./hu/_lib/localize/index": [
		19394,
		7,
		19394
	],
	"./hu/_lib/localize/index.js": [
		19394,
		7,
		19394
	],
	"./hu/_lib/match": [
		71040,
		7,
		71040
	],
	"./hu/_lib/match/": [
		71040,
		7,
		71040
	],
	"./hu/_lib/match/index": [
		71040,
		7,
		71040
	],
	"./hu/_lib/match/index.js": [
		71040,
		7,
		71040
	],
	"./hu/index": [
		69365,
		7,
		69365
	],
	"./hu/index.d": [
		17201,
		9,
		17201
	],
	"./hu/index.d.ts": [
		17201,
		9,
		17201
	],
	"./hu/index.js": [
		69365,
		7,
		69365
	],
	"./hu/index.js.flow": [
		54912,
		1,
		54912
	],
	"./hu/package": [
		60270,
		3,
		60270
	],
	"./hu/package.json": [
		60270,
		3,
		60270
	],
	"./hy": [
		86061,
		9,
		86061
	],
	"./hy/": [
		86061,
		9,
		86061
	],
	"./hy/_lib/formatDistance": [
		19305,
		7,
		19305
	],
	"./hy/_lib/formatDistance/": [
		19305,
		7,
		19305
	],
	"./hy/_lib/formatDistance/index": [
		19305,
		7,
		19305
	],
	"./hy/_lib/formatDistance/index.js": [
		19305,
		7,
		19305
	],
	"./hy/_lib/formatLong": [
		84281,
		7,
		84281
	],
	"./hy/_lib/formatLong/": [
		84281,
		7,
		84281
	],
	"./hy/_lib/formatLong/index": [
		84281,
		7,
		84281
	],
	"./hy/_lib/formatLong/index.js": [
		84281,
		7,
		84281
	],
	"./hy/_lib/formatRelative": [
		58384,
		7,
		58384
	],
	"./hy/_lib/formatRelative/": [
		58384,
		7,
		58384
	],
	"./hy/_lib/formatRelative/index": [
		58384,
		7,
		58384
	],
	"./hy/_lib/formatRelative/index.js": [
		58384,
		7,
		58384
	],
	"./hy/_lib/localize": [
		94065,
		7,
		94065
	],
	"./hy/_lib/localize/": [
		94065,
		7,
		94065
	],
	"./hy/_lib/localize/index": [
		94065,
		7,
		94065
	],
	"./hy/_lib/localize/index.js": [
		94065,
		7,
		94065
	],
	"./hy/_lib/match": [
		31848,
		7,
		31848
	],
	"./hy/_lib/match/": [
		31848,
		7,
		31848
	],
	"./hy/_lib/match/index": [
		31848,
		7,
		31848
	],
	"./hy/_lib/match/index.js": [
		31848,
		7,
		31848
	],
	"./hy/index": [
		74323,
		7,
		74323
	],
	"./hy/index.d": [
		44599,
		9,
		44599
	],
	"./hy/index.d.ts": [
		44599,
		9,
		44599
	],
	"./hy/index.js": [
		74323,
		7,
		74323
	],
	"./hy/index.js.flow": [
		33129,
		1,
		33129
	],
	"./hy/package": [
		34137,
		3,
		34137
	],
	"./hy/package.json": [
		34137,
		3,
		34137
	],
	"./id": [
		59118,
		9,
		59118
	],
	"./id/": [
		59118,
		9,
		59118
	],
	"./id/_lib/formatDistance": [
		34750,
		7,
		34750
	],
	"./id/_lib/formatDistance/": [
		34750,
		7,
		34750
	],
	"./id/_lib/formatDistance/index": [
		34750,
		7,
		34750
	],
	"./id/_lib/formatDistance/index.js": [
		34750,
		7,
		34750
	],
	"./id/_lib/formatLong": [
		92067,
		7,
		92067
	],
	"./id/_lib/formatLong/": [
		92067,
		7,
		92067
	],
	"./id/_lib/formatLong/index": [
		92067,
		7,
		92067
	],
	"./id/_lib/formatLong/index.js": [
		92067,
		7,
		92067
	],
	"./id/_lib/formatRelative": [
		45962,
		7,
		45962
	],
	"./id/_lib/formatRelative/": [
		45962,
		7,
		45962
	],
	"./id/_lib/formatRelative/index": [
		45962,
		7,
		45962
	],
	"./id/_lib/formatRelative/index.js": [
		45962,
		7,
		45962
	],
	"./id/_lib/localize": [
		22996,
		7,
		22996
	],
	"./id/_lib/localize/": [
		22996,
		7,
		22996
	],
	"./id/_lib/localize/index": [
		22996,
		7,
		22996
	],
	"./id/_lib/localize/index.js": [
		22996,
		7,
		22996
	],
	"./id/_lib/match": [
		53189,
		7,
		53189
	],
	"./id/_lib/match/": [
		53189,
		7,
		53189
	],
	"./id/_lib/match/index": [
		53189,
		7,
		53189
	],
	"./id/_lib/match/index.js": [
		53189,
		7,
		53189
	],
	"./id/index": [
		20042,
		7,
		20042
	],
	"./id/index.d": [
		1256,
		9,
		1256
	],
	"./id/index.d.ts": [
		1256,
		9,
		1256
	],
	"./id/index.js": [
		20042,
		7,
		20042
	],
	"./id/index.js.flow": [
		47249,
		1,
		47249
	],
	"./id/package": [
		72723,
		3,
		72723
	],
	"./id/package.json": [
		72723,
		3,
		72723
	],
	"./index": [
		6345,
		9,
		62557,
		28336,
		31957,
		61667,
		50649,
		6345
	],
	"./index.js": [
		6345,
		9,
		62557,
		28336,
		31957,
		61667,
		50649,
		6345
	],
	"./index.js.flow": [
		30767,
		1,
		30767
	],
	"./is": [
		32151,
		9,
		32151
	],
	"./is/": [
		32151,
		9,
		32151
	],
	"./is/_lib/formatDistance": [
		26183,
		7,
		26183
	],
	"./is/_lib/formatDistance/": [
		26183,
		7,
		26183
	],
	"./is/_lib/formatDistance/index": [
		26183,
		7,
		26183
	],
	"./is/_lib/formatDistance/index.js": [
		26183,
		7,
		26183
	],
	"./is/_lib/formatLong": [
		18892,
		7,
		18892
	],
	"./is/_lib/formatLong/": [
		18892,
		7,
		18892
	],
	"./is/_lib/formatLong/index": [
		18892,
		7,
		18892
	],
	"./is/_lib/formatLong/index.js": [
		18892,
		7,
		18892
	],
	"./is/_lib/formatRelative": [
		55703,
		7,
		55703
	],
	"./is/_lib/formatRelative/": [
		55703,
		7,
		55703
	],
	"./is/_lib/formatRelative/index": [
		55703,
		7,
		55703
	],
	"./is/_lib/formatRelative/index.js": [
		55703,
		7,
		55703
	],
	"./is/_lib/localize": [
		36186,
		7,
		36186
	],
	"./is/_lib/localize/": [
		36186,
		7,
		36186
	],
	"./is/_lib/localize/index": [
		36186,
		7,
		36186
	],
	"./is/_lib/localize/index.js": [
		36186,
		7,
		36186
	],
	"./is/_lib/match": [
		79418,
		7,
		79418
	],
	"./is/_lib/match/": [
		79418,
		7,
		79418
	],
	"./is/_lib/match/index": [
		79418,
		7,
		79418
	],
	"./is/_lib/match/index.js": [
		79418,
		7,
		79418
	],
	"./is/index": [
		53220,
		7,
		53220
	],
	"./is/index.d": [
		63261,
		9,
		63261
	],
	"./is/index.d.ts": [
		63261,
		9,
		63261
	],
	"./is/index.js": [
		53220,
		7,
		53220
	],
	"./is/index.js.flow": [
		19728,
		1,
		19728
	],
	"./is/package": [
		54647,
		3,
		54647
	],
	"./is/package.json": [
		54647,
		3,
		54647
	],
	"./it": [
		3412,
		9,
		3412
	],
	"./it/": [
		3412,
		9,
		3412
	],
	"./it/_lib/formatDistance": [
		32607,
		7,
		32607
	],
	"./it/_lib/formatDistance/": [
		32607,
		7,
		32607
	],
	"./it/_lib/formatDistance/index": [
		32607,
		7,
		32607
	],
	"./it/_lib/formatDistance/index.js": [
		32607,
		7,
		32607
	],
	"./it/_lib/formatLong": [
		82823,
		7,
		82823
	],
	"./it/_lib/formatLong/": [
		82823,
		7,
		82823
	],
	"./it/_lib/formatLong/index": [
		82823,
		7,
		82823
	],
	"./it/_lib/formatLong/index.js": [
		82823,
		7,
		82823
	],
	"./it/_lib/formatRelative": [
		73614,
		7,
		73614
	],
	"./it/_lib/formatRelative/": [
		73614,
		7,
		73614
	],
	"./it/_lib/formatRelative/index": [
		73614,
		7,
		73614
	],
	"./it/_lib/formatRelative/index.js": [
		73614,
		7,
		73614
	],
	"./it/_lib/localize": [
		13423,
		7,
		13423
	],
	"./it/_lib/localize/": [
		13423,
		7,
		13423
	],
	"./it/_lib/localize/index": [
		13423,
		7,
		13423
	],
	"./it/_lib/localize/index.js": [
		13423,
		7,
		13423
	],
	"./it/_lib/match": [
		98799,
		7,
		98799
	],
	"./it/_lib/match/": [
		98799,
		7,
		98799
	],
	"./it/_lib/match/index": [
		98799,
		7,
		98799
	],
	"./it/_lib/match/index.js": [
		98799,
		7,
		98799
	],
	"./it/index": [
		75958,
		7,
		75958
	],
	"./it/index.d": [
		36777,
		9,
		36777
	],
	"./it/index.d.ts": [
		36777,
		9,
		36777
	],
	"./it/index.js": [
		75958,
		7,
		75958
	],
	"./it/index.js.flow": [
		92724,
		1,
		92724
	],
	"./it/package": [
		5532,
		3,
		5532
	],
	"./it/package.json": [
		5532,
		3,
		5532
	],
	"./ja": [
		93448,
		9,
		93448
	],
	"./ja/": [
		93448,
		9,
		93448
	],
	"./ja/_lib/formatDistance": [
		65255,
		7,
		65255
	],
	"./ja/_lib/formatDistance/": [
		65255,
		7,
		65255
	],
	"./ja/_lib/formatDistance/index": [
		65255,
		7,
		65255
	],
	"./ja/_lib/formatDistance/index.js": [
		65255,
		7,
		65255
	],
	"./ja/_lib/formatLong": [
		49039,
		7,
		49039
	],
	"./ja/_lib/formatLong/": [
		49039,
		7,
		49039
	],
	"./ja/_lib/formatLong/index": [
		49039,
		7,
		49039
	],
	"./ja/_lib/formatLong/index.js": [
		49039,
		7,
		49039
	],
	"./ja/_lib/formatRelative": [
		121,
		7,
		121
	],
	"./ja/_lib/formatRelative/": [
		121,
		7,
		121
	],
	"./ja/_lib/formatRelative/index": [
		121,
		7,
		121
	],
	"./ja/_lib/formatRelative/index.js": [
		121,
		7,
		121
	],
	"./ja/_lib/localize": [
		69188,
		7,
		69188
	],
	"./ja/_lib/localize/": [
		69188,
		7,
		69188
	],
	"./ja/_lib/localize/index": [
		69188,
		7,
		69188
	],
	"./ja/_lib/localize/index.js": [
		69188,
		7,
		69188
	],
	"./ja/_lib/match": [
		86488,
		7,
		86488
	],
	"./ja/_lib/match/": [
		86488,
		7,
		86488
	],
	"./ja/_lib/match/index": [
		86488,
		7,
		86488
	],
	"./ja/_lib/match/index.js": [
		86488,
		7,
		86488
	],
	"./ja/index": [
		79221,
		7,
		79221
	],
	"./ja/index.d": [
		90744,
		9,
		90744
	],
	"./ja/index.d.ts": [
		90744,
		9,
		90744
	],
	"./ja/index.js": [
		79221,
		7,
		79221
	],
	"./ja/index.js.flow": [
		92220,
		1,
		92220
	],
	"./ja/package": [
		41487,
		3,
		41487
	],
	"./ja/package.json": [
		41487,
		3,
		41487
	],
	"./ka": [
		46118,
		9,
		46118
	],
	"./ka/": [
		46118,
		9,
		46118
	],
	"./ka/_lib/formatDistance": [
		74379,
		7,
		74379
	],
	"./ka/_lib/formatDistance/": [
		74379,
		7,
		74379
	],
	"./ka/_lib/formatDistance/index": [
		74379,
		7,
		74379
	],
	"./ka/_lib/formatDistance/index.js": [
		74379,
		7,
		74379
	],
	"./ka/_lib/formatLong": [
		46577,
		7,
		46577
	],
	"./ka/_lib/formatLong/": [
		46577,
		7,
		46577
	],
	"./ka/_lib/formatLong/index": [
		46577,
		7,
		46577
	],
	"./ka/_lib/formatLong/index.js": [
		46577,
		7,
		46577
	],
	"./ka/_lib/formatRelative": [
		34857,
		7,
		34857
	],
	"./ka/_lib/formatRelative/": [
		34857,
		7,
		34857
	],
	"./ka/_lib/formatRelative/index": [
		34857,
		7,
		34857
	],
	"./ka/_lib/formatRelative/index.js": [
		34857,
		7,
		34857
	],
	"./ka/_lib/localize": [
		35398,
		7,
		35398
	],
	"./ka/_lib/localize/": [
		35398,
		7,
		35398
	],
	"./ka/_lib/localize/index": [
		35398,
		7,
		35398
	],
	"./ka/_lib/localize/index.js": [
		35398,
		7,
		35398
	],
	"./ka/_lib/match": [
		82035,
		7,
		82035
	],
	"./ka/_lib/match/": [
		82035,
		7,
		82035
	],
	"./ka/_lib/match/index": [
		82035,
		7,
		82035
	],
	"./ka/_lib/match/index.js": [
		82035,
		7,
		82035
	],
	"./ka/index": [
		91745,
		7,
		91745
	],
	"./ka/index.d": [
		72949,
		9,
		72949
	],
	"./ka/index.d.ts": [
		72949,
		9,
		72949
	],
	"./ka/index.js": [
		91745,
		7,
		91745
	],
	"./ka/index.js.flow": [
		84548,
		1,
		84548
	],
	"./ka/package": [
		96507,
		3,
		96507
	],
	"./ka/package.json": [
		96507,
		3,
		96507
	],
	"./kk": [
		89818,
		9,
		89818
	],
	"./kk/": [
		89818,
		9,
		89818
	],
	"./kk/_lib/formatDistance": [
		81434,
		7,
		81434
	],
	"./kk/_lib/formatDistance/": [
		81434,
		7,
		81434
	],
	"./kk/_lib/formatDistance/index": [
		81434,
		7,
		81434
	],
	"./kk/_lib/formatDistance/index.js": [
		81434,
		7,
		81434
	],
	"./kk/_lib/formatLong": [
		12189,
		7,
		12189
	],
	"./kk/_lib/formatLong/": [
		12189,
		7,
		12189
	],
	"./kk/_lib/formatLong/index": [
		12189,
		7,
		12189
	],
	"./kk/_lib/formatLong/index.js": [
		12189,
		7,
		12189
	],
	"./kk/_lib/formatRelative": [
		75192,
		7,
		75192
	],
	"./kk/_lib/formatRelative/": [
		75192,
		7,
		75192
	],
	"./kk/_lib/formatRelative/index": [
		75192,
		7,
		75192
	],
	"./kk/_lib/formatRelative/index.js": [
		75192,
		7,
		75192
	],
	"./kk/_lib/localize": [
		71871,
		7,
		71871
	],
	"./kk/_lib/localize/": [
		71871,
		7,
		71871
	],
	"./kk/_lib/localize/index": [
		71871,
		7,
		71871
	],
	"./kk/_lib/localize/index.js": [
		71871,
		7,
		71871
	],
	"./kk/_lib/match": [
		22365,
		7,
		22365
	],
	"./kk/_lib/match/": [
		22365,
		7,
		22365
	],
	"./kk/_lib/match/index": [
		22365,
		7,
		22365
	],
	"./kk/_lib/match/index.js": [
		22365,
		7,
		22365
	],
	"./kk/index": [
		50649,
		7,
		50649,
		3604
	],
	"./kk/index.d": [
		35359,
		9,
		35359
	],
	"./kk/index.d.ts": [
		35359,
		9,
		35359
	],
	"./kk/index.js": [
		50649,
		7,
		50649,
		3604
	],
	"./kk/index.js.flow": [
		48954,
		1,
		48954
	],
	"./kk/package": [
		99156,
		3,
		99156
	],
	"./kk/package.json": [
		99156,
		3,
		99156
	],
	"./kn": [
		82584,
		9,
		82584
	],
	"./kn/": [
		82584,
		9,
		82584
	],
	"./kn/_lib/formatDistance": [
		73384,
		7,
		73384
	],
	"./kn/_lib/formatDistance/": [
		73384,
		7,
		73384
	],
	"./kn/_lib/formatDistance/index": [
		73384,
		7,
		73384
	],
	"./kn/_lib/formatDistance/index.js": [
		73384,
		7,
		73384
	],
	"./kn/_lib/formatLong": [
		6145,
		7,
		6145
	],
	"./kn/_lib/formatLong/": [
		6145,
		7,
		6145
	],
	"./kn/_lib/formatLong/index": [
		6145,
		7,
		6145
	],
	"./kn/_lib/formatLong/index.js": [
		6145,
		7,
		6145
	],
	"./kn/_lib/formatRelative": [
		11272,
		7,
		11272
	],
	"./kn/_lib/formatRelative/": [
		11272,
		7,
		11272
	],
	"./kn/_lib/formatRelative/index": [
		11272,
		7,
		11272
	],
	"./kn/_lib/formatRelative/index.js": [
		11272,
		7,
		11272
	],
	"./kn/_lib/localize": [
		24777,
		7,
		24777
	],
	"./kn/_lib/localize/": [
		24777,
		7,
		24777
	],
	"./kn/_lib/localize/index": [
		24777,
		7,
		24777
	],
	"./kn/_lib/localize/index.js": [
		24777,
		7,
		24777
	],
	"./kn/_lib/match": [
		12730,
		7,
		12730
	],
	"./kn/_lib/match/": [
		12730,
		7,
		12730
	],
	"./kn/_lib/match/index": [
		12730,
		7,
		12730
	],
	"./kn/_lib/match/index.js": [
		12730,
		7,
		12730
	],
	"./kn/index": [
		71585,
		7,
		71585
	],
	"./kn/index.d": [
		85878,
		9,
		85878
	],
	"./kn/index.d.ts": [
		85878,
		9,
		85878
	],
	"./kn/index.js": [
		71585,
		7,
		71585
	],
	"./kn/index.js.flow": [
		2813,
		1,
		2813
	],
	"./kn/package": [
		20621,
		3,
		20621
	],
	"./kn/package.json": [
		20621,
		3,
		20621
	],
	"./ko": [
		50584,
		9,
		50584
	],
	"./ko/": [
		50584,
		9,
		50584
	],
	"./ko/_lib/formatDistance": [
		88153,
		7,
		88153
	],
	"./ko/_lib/formatDistance/": [
		88153,
		7,
		88153
	],
	"./ko/_lib/formatDistance/index": [
		88153,
		7,
		88153
	],
	"./ko/_lib/formatDistance/index.js": [
		88153,
		7,
		88153
	],
	"./ko/_lib/formatLong": [
		88812,
		7,
		88812
	],
	"./ko/_lib/formatLong/": [
		88812,
		7,
		88812
	],
	"./ko/_lib/formatLong/index": [
		88812,
		7,
		88812
	],
	"./ko/_lib/formatLong/index.js": [
		88812,
		7,
		88812
	],
	"./ko/_lib/formatRelative": [
		8112,
		7,
		8112
	],
	"./ko/_lib/formatRelative/": [
		8112,
		7,
		8112
	],
	"./ko/_lib/formatRelative/index": [
		8112,
		7,
		8112
	],
	"./ko/_lib/formatRelative/index.js": [
		8112,
		7,
		8112
	],
	"./ko/_lib/localize": [
		98101,
		7,
		98101
	],
	"./ko/_lib/localize/": [
		98101,
		7,
		98101
	],
	"./ko/_lib/localize/index": [
		98101,
		7,
		98101
	],
	"./ko/_lib/localize/index.js": [
		98101,
		7,
		98101
	],
	"./ko/_lib/match": [
		32712,
		7,
		32712
	],
	"./ko/_lib/match/": [
		32712,
		7,
		32712
	],
	"./ko/_lib/match/index": [
		32712,
		7,
		32712
	],
	"./ko/_lib/match/index.js": [
		32712,
		7,
		32712
	],
	"./ko/index": [
		29792,
		7,
		29792
	],
	"./ko/index.d": [
		39130,
		9,
		39130
	],
	"./ko/index.d.ts": [
		39130,
		9,
		39130
	],
	"./ko/index.js": [
		29792,
		7,
		29792
	],
	"./ko/index.js.flow": [
		71999,
		1,
		71999
	],
	"./ko/package": [
		17069,
		3,
		17069
	],
	"./ko/package.json": [
		17069,
		3,
		17069
	],
	"./lb": [
		57287,
		9,
		57287
	],
	"./lb/": [
		57287,
		9,
		57287
	],
	"./lb/_lib/formatDistance": [
		62553,
		7,
		62553
	],
	"./lb/_lib/formatDistance/": [
		62553,
		7,
		62553
	],
	"./lb/_lib/formatDistance/index": [
		62553,
		7,
		62553
	],
	"./lb/_lib/formatDistance/index.js": [
		62553,
		7,
		62553
	],
	"./lb/_lib/formatLong": [
		53091,
		7,
		53091
	],
	"./lb/_lib/formatLong/": [
		53091,
		7,
		53091
	],
	"./lb/_lib/formatLong/index": [
		53091,
		7,
		53091
	],
	"./lb/_lib/formatLong/index.js": [
		53091,
		7,
		53091
	],
	"./lb/_lib/formatRelative": [
		69449,
		7,
		69449
	],
	"./lb/_lib/formatRelative/": [
		69449,
		7,
		69449
	],
	"./lb/_lib/formatRelative/index": [
		69449,
		7,
		69449
	],
	"./lb/_lib/formatRelative/index.js": [
		69449,
		7,
		69449
	],
	"./lb/_lib/localize": [
		62538,
		7,
		62538
	],
	"./lb/_lib/localize/": [
		62538,
		7,
		62538
	],
	"./lb/_lib/localize/index": [
		62538,
		7,
		62538
	],
	"./lb/_lib/localize/index.js": [
		62538,
		7,
		62538
	],
	"./lb/_lib/match": [
		8279,
		7,
		8279
	],
	"./lb/_lib/match/": [
		8279,
		7,
		8279
	],
	"./lb/_lib/match/index": [
		8279,
		7,
		8279
	],
	"./lb/_lib/match/index.js": [
		8279,
		7,
		8279
	],
	"./lb/index": [
		8528,
		7,
		65109
	],
	"./lb/index.d": [
		66015,
		9,
		66015
	],
	"./lb/index.d.ts": [
		66015,
		9,
		66015
	],
	"./lb/index.js": [
		8528,
		7,
		65109
	],
	"./lb/index.js.flow": [
		81567,
		1,
		81567
	],
	"./lb/package": [
		80719,
		3,
		80719
	],
	"./lb/package.json": [
		80719,
		3,
		80719
	],
	"./lt": [
		34210,
		9,
		34210
	],
	"./lt/": [
		34210,
		9,
		34210
	],
	"./lt/_lib/formatDistance": [
		14611,
		7,
		14611
	],
	"./lt/_lib/formatDistance/": [
		14611,
		7,
		14611
	],
	"./lt/_lib/formatDistance/index": [
		14611,
		7,
		14611
	],
	"./lt/_lib/formatDistance/index.js": [
		14611,
		7,
		14611
	],
	"./lt/_lib/formatLong": [
		51068,
		7,
		51068
	],
	"./lt/_lib/formatLong/": [
		51068,
		7,
		51068
	],
	"./lt/_lib/formatLong/index": [
		51068,
		7,
		51068
	],
	"./lt/_lib/formatLong/index.js": [
		51068,
		7,
		51068
	],
	"./lt/_lib/formatRelative": [
		36905,
		7,
		36905
	],
	"./lt/_lib/formatRelative/": [
		36905,
		7,
		36905
	],
	"./lt/_lib/formatRelative/index": [
		36905,
		7,
		36905
	],
	"./lt/_lib/formatRelative/index.js": [
		36905,
		7,
		36905
	],
	"./lt/_lib/localize": [
		21133,
		7,
		21133
	],
	"./lt/_lib/localize/": [
		21133,
		7,
		21133
	],
	"./lt/_lib/localize/index": [
		21133,
		7,
		21133
	],
	"./lt/_lib/localize/index.js": [
		21133,
		7,
		21133
	],
	"./lt/_lib/match": [
		77088,
		7,
		77088
	],
	"./lt/_lib/match/": [
		77088,
		7,
		77088
	],
	"./lt/_lib/match/index": [
		77088,
		7,
		77088
	],
	"./lt/_lib/match/index.js": [
		77088,
		7,
		77088
	],
	"./lt/index": [
		50771,
		7,
		50771
	],
	"./lt/index.d": [
		70192,
		9,
		70192
	],
	"./lt/index.d.ts": [
		70192,
		9,
		70192
	],
	"./lt/index.js": [
		50771,
		7,
		50771
	],
	"./lt/index.js.flow": [
		46595,
		1,
		46595
	],
	"./lt/package": [
		98168,
		3,
		98168
	],
	"./lt/package.json": [
		98168,
		3,
		98168
	],
	"./lv": [
		79882,
		9,
		79882
	],
	"./lv/": [
		79882,
		9,
		79882
	],
	"./lv/_lib/formatDistance": [
		58603,
		7,
		58603
	],
	"./lv/_lib/formatDistance/": [
		58603,
		7,
		58603
	],
	"./lv/_lib/formatDistance/index": [
		58603,
		7,
		58603
	],
	"./lv/_lib/formatDistance/index.js": [
		58603,
		7,
		58603
	],
	"./lv/_lib/formatLong": [
		76209,
		7,
		76209
	],
	"./lv/_lib/formatLong/": [
		76209,
		7,
		76209
	],
	"./lv/_lib/formatLong/index": [
		76209,
		7,
		76209
	],
	"./lv/_lib/formatLong/index.js": [
		76209,
		7,
		76209
	],
	"./lv/_lib/formatRelative": [
		88663,
		7,
		88663
	],
	"./lv/_lib/formatRelative/": [
		88663,
		7,
		88663
	],
	"./lv/_lib/formatRelative/index": [
		88663,
		7,
		88663
	],
	"./lv/_lib/formatRelative/index.js": [
		88663,
		7,
		88663
	],
	"./lv/_lib/localize": [
		30128,
		7,
		30128
	],
	"./lv/_lib/localize/": [
		30128,
		7,
		30128
	],
	"./lv/_lib/localize/index": [
		30128,
		7,
		30128
	],
	"./lv/_lib/localize/index.js": [
		30128,
		7,
		30128
	],
	"./lv/_lib/match": [
		3665,
		7,
		3665
	],
	"./lv/_lib/match/": [
		3665,
		7,
		3665
	],
	"./lv/_lib/match/index": [
		3665,
		7,
		3665
	],
	"./lv/_lib/match/index.js": [
		3665,
		7,
		3665
	],
	"./lv/index": [
		3789,
		7,
		3789
	],
	"./lv/index.d": [
		84236,
		9,
		84236
	],
	"./lv/index.d.ts": [
		84236,
		9,
		84236
	],
	"./lv/index.js": [
		3789,
		7,
		3789
	],
	"./lv/index.js.flow": [
		24672,
		1,
		24672
	],
	"./lv/package": [
		9186,
		3,
		9186
	],
	"./lv/package.json": [
		9186,
		3,
		9186
	],
	"./mk": [
		33596,
		9,
		33596
	],
	"./mk/": [
		33596,
		9,
		33596
	],
	"./mk/_lib/formatDistance": [
		13515,
		7,
		13515
	],
	"./mk/_lib/formatDistance/": [
		13515,
		7,
		13515
	],
	"./mk/_lib/formatDistance/index": [
		13515,
		7,
		13515
	],
	"./mk/_lib/formatDistance/index.js": [
		13515,
		7,
		13515
	],
	"./mk/_lib/formatLong": [
		32273,
		7,
		32273
	],
	"./mk/_lib/formatLong/": [
		32273,
		7,
		32273
	],
	"./mk/_lib/formatLong/index": [
		32273,
		7,
		32273
	],
	"./mk/_lib/formatLong/index.js": [
		32273,
		7,
		32273
	],
	"./mk/_lib/formatRelative": [
		45373,
		7,
		45373
	],
	"./mk/_lib/formatRelative/": [
		45373,
		7,
		45373
	],
	"./mk/_lib/formatRelative/index": [
		45373,
		7,
		45373
	],
	"./mk/_lib/formatRelative/index.js": [
		45373,
		7,
		45373
	],
	"./mk/_lib/localize": [
		80580,
		7,
		80580
	],
	"./mk/_lib/localize/": [
		80580,
		7,
		80580
	],
	"./mk/_lib/localize/index": [
		80580,
		7,
		80580
	],
	"./mk/_lib/localize/index.js": [
		80580,
		7,
		80580
	],
	"./mk/_lib/match": [
		63125,
		7,
		63125
	],
	"./mk/_lib/match/": [
		63125,
		7,
		63125
	],
	"./mk/_lib/match/index": [
		63125,
		7,
		63125
	],
	"./mk/_lib/match/index.js": [
		63125,
		7,
		63125
	],
	"./mk/index": [
		50283,
		7,
		50283
	],
	"./mk/index.d": [
		2957,
		9,
		2957
	],
	"./mk/index.d.ts": [
		2957,
		9,
		2957
	],
	"./mk/index.js": [
		50283,
		7,
		50283
	],
	"./mk/index.js.flow": [
		5596,
		1,
		5596
	],
	"./mk/package": [
		61398,
		3,
		61398
	],
	"./mk/package.json": [
		61398,
		3,
		61398
	],
	"./mn": [
		63501,
		9,
		63501
	],
	"./mn/": [
		63501,
		9,
		63501
	],
	"./mn/_lib/formatDistance": [
		7295,
		7,
		7295
	],
	"./mn/_lib/formatDistance/": [
		7295,
		7,
		7295
	],
	"./mn/_lib/formatDistance/index": [
		7295,
		7,
		7295
	],
	"./mn/_lib/formatDistance/index.js": [
		7295,
		7,
		7295
	],
	"./mn/_lib/formatLong": [
		47217,
		7,
		47217
	],
	"./mn/_lib/formatLong/": [
		47217,
		7,
		47217
	],
	"./mn/_lib/formatLong/index": [
		47217,
		7,
		47217
	],
	"./mn/_lib/formatLong/index.js": [
		47217,
		7,
		47217
	],
	"./mn/_lib/formatRelative": [
		84043,
		7,
		84043
	],
	"./mn/_lib/formatRelative/": [
		84043,
		7,
		84043
	],
	"./mn/_lib/formatRelative/index": [
		84043,
		7,
		84043
	],
	"./mn/_lib/formatRelative/index.js": [
		84043,
		7,
		84043
	],
	"./mn/_lib/localize": [
		68211,
		7,
		68211
	],
	"./mn/_lib/localize/": [
		68211,
		7,
		68211
	],
	"./mn/_lib/localize/index": [
		68211,
		7,
		68211
	],
	"./mn/_lib/localize/index.js": [
		68211,
		7,
		68211
	],
	"./mn/_lib/match": [
		50612,
		7,
		50612
	],
	"./mn/_lib/match/": [
		50612,
		7,
		50612
	],
	"./mn/_lib/match/index": [
		50612,
		7,
		50612
	],
	"./mn/_lib/match/index.js": [
		50612,
		7,
		50612
	],
	"./mn/index": [
		90432,
		7,
		90432
	],
	"./mn/index.d": [
		11667,
		9,
		11667
	],
	"./mn/index.d.ts": [
		11667,
		9,
		11667
	],
	"./mn/index.js": [
		90432,
		7,
		90432
	],
	"./mn/index.js.flow": [
		39870,
		1,
		39870
	],
	"./mn/package": [
		20045,
		3,
		20045
	],
	"./mn/package.json": [
		20045,
		3,
		20045
	],
	"./ms": [
		91761,
		9,
		91761
	],
	"./ms/": [
		91761,
		9,
		91761
	],
	"./ms/_lib/formatDistance": [
		32825,
		7,
		32825
	],
	"./ms/_lib/formatDistance/": [
		32825,
		7,
		32825
	],
	"./ms/_lib/formatDistance/index": [
		32825,
		7,
		32825
	],
	"./ms/_lib/formatDistance/index.js": [
		32825,
		7,
		32825
	],
	"./ms/_lib/formatLong": [
		81740,
		7,
		81740
	],
	"./ms/_lib/formatLong/": [
		81740,
		7,
		81740
	],
	"./ms/_lib/formatLong/index": [
		81740,
		7,
		81740
	],
	"./ms/_lib/formatLong/index.js": [
		81740,
		7,
		81740
	],
	"./ms/_lib/formatRelative": [
		78558,
		7,
		78558
	],
	"./ms/_lib/formatRelative/": [
		78558,
		7,
		78558
	],
	"./ms/_lib/formatRelative/index": [
		78558,
		7,
		78558
	],
	"./ms/_lib/formatRelative/index.js": [
		78558,
		7,
		78558
	],
	"./ms/_lib/localize": [
		85834,
		7,
		85834
	],
	"./ms/_lib/localize/": [
		85834,
		7,
		85834
	],
	"./ms/_lib/localize/index": [
		85834,
		7,
		85834
	],
	"./ms/_lib/localize/index.js": [
		85834,
		7,
		85834
	],
	"./ms/_lib/match": [
		61850,
		7,
		61850
	],
	"./ms/_lib/match/": [
		61850,
		7,
		61850
	],
	"./ms/_lib/match/index": [
		61850,
		7,
		61850
	],
	"./ms/_lib/match/index.js": [
		61850,
		7,
		61850
	],
	"./ms/index": [
		25947,
		7,
		25947
	],
	"./ms/index.d": [
		63368,
		9,
		63368
	],
	"./ms/index.d.ts": [
		63368,
		9,
		63368
	],
	"./ms/index.js": [
		25947,
		7,
		25947
	],
	"./ms/index.js.flow": [
		95438,
		1,
		95438
	],
	"./ms/package": [
		69596,
		3,
		69596
	],
	"./ms/package.json": [
		69596,
		3,
		69596
	],
	"./mt": [
		4783,
		9,
		4783
	],
	"./mt/": [
		4783,
		9,
		4783
	],
	"./mt/_lib/formatDistance": [
		43869,
		7,
		43869
	],
	"./mt/_lib/formatDistance/": [
		43869,
		7,
		43869
	],
	"./mt/_lib/formatDistance/index": [
		43869,
		7,
		43869
	],
	"./mt/_lib/formatDistance/index.js": [
		43869,
		7,
		43869
	],
	"./mt/_lib/formatLong": [
		1060,
		7,
		1060
	],
	"./mt/_lib/formatLong/": [
		1060,
		7,
		1060
	],
	"./mt/_lib/formatLong/index": [
		1060,
		7,
		1060
	],
	"./mt/_lib/formatLong/index.js": [
		1060,
		7,
		1060
	],
	"./mt/_lib/formatRelative": [
		25948,
		7,
		25948
	],
	"./mt/_lib/formatRelative/": [
		25948,
		7,
		25948
	],
	"./mt/_lib/formatRelative/index": [
		25948,
		7,
		25948
	],
	"./mt/_lib/formatRelative/index.js": [
		25948,
		7,
		25948
	],
	"./mt/_lib/localize": [
		42092,
		7,
		42092
	],
	"./mt/_lib/localize/": [
		42092,
		7,
		42092
	],
	"./mt/_lib/localize/index": [
		42092,
		7,
		42092
	],
	"./mt/_lib/localize/index.js": [
		42092,
		7,
		42092
	],
	"./mt/_lib/match": [
		44825,
		7,
		44825
	],
	"./mt/_lib/match/": [
		44825,
		7,
		44825
	],
	"./mt/_lib/match/index": [
		44825,
		7,
		44825
	],
	"./mt/_lib/match/index.js": [
		44825,
		7,
		44825
	],
	"./mt/index": [
		25436,
		7,
		25436
	],
	"./mt/index.d": [
		23719,
		9,
		23719
	],
	"./mt/index.d.ts": [
		23719,
		9,
		23719
	],
	"./mt/index.js": [
		25436,
		7,
		25436
	],
	"./mt/index.js.flow": [
		30392,
		1,
		30392
	],
	"./mt/package": [
		79851,
		3,
		79851
	],
	"./mt/package.json": [
		79851,
		3,
		79851
	],
	"./nb": [
		70469,
		9,
		70469
	],
	"./nb/": [
		70469,
		9,
		70469
	],
	"./nb/_lib/formatDistance": [
		80691,
		7,
		80691
	],
	"./nb/_lib/formatDistance/": [
		80691,
		7,
		80691
	],
	"./nb/_lib/formatDistance/index": [
		80691,
		7,
		80691
	],
	"./nb/_lib/formatDistance/index.js": [
		80691,
		7,
		80691
	],
	"./nb/_lib/formatLong": [
		78361,
		7,
		78361
	],
	"./nb/_lib/formatLong/": [
		78361,
		7,
		78361
	],
	"./nb/_lib/formatLong/index": [
		78361,
		7,
		78361
	],
	"./nb/_lib/formatLong/index.js": [
		78361,
		7,
		78361
	],
	"./nb/_lib/formatRelative": [
		38874,
		7,
		38874
	],
	"./nb/_lib/formatRelative/": [
		38874,
		7,
		38874
	],
	"./nb/_lib/formatRelative/index": [
		38874,
		7,
		38874
	],
	"./nb/_lib/formatRelative/index.js": [
		38874,
		7,
		38874
	],
	"./nb/_lib/localize": [
		20384,
		7,
		20384
	],
	"./nb/_lib/localize/": [
		20384,
		7,
		20384
	],
	"./nb/_lib/localize/index": [
		20384,
		7,
		20384
	],
	"./nb/_lib/localize/index.js": [
		20384,
		7,
		20384
	],
	"./nb/_lib/match": [
		78614,
		7,
		78614
	],
	"./nb/_lib/match/": [
		78614,
		7,
		78614
	],
	"./nb/_lib/match/index": [
		78614,
		7,
		78614
	],
	"./nb/_lib/match/index.js": [
		78614,
		7,
		78614
	],
	"./nb/index": [
		35679,
		7,
		35679
	],
	"./nb/index.d": [
		17835,
		9,
		17835
	],
	"./nb/index.d.ts": [
		17835,
		9,
		17835
	],
	"./nb/index.js": [
		35679,
		7,
		35679
	],
	"./nb/index.js.flow": [
		16011,
		1,
		16011
	],
	"./nb/package": [
		33732,
		3,
		33732
	],
	"./nb/package.json": [
		33732,
		3,
		33732
	],
	"./nl": [
		59084,
		9,
		59084
	],
	"./nl-BE": [
		51391,
		9,
		51391
	],
	"./nl-BE/": [
		51391,
		9,
		51391
	],
	"./nl-BE/_lib/formatDistance": [
		42055,
		7,
		42055
	],
	"./nl-BE/_lib/formatDistance/": [
		42055,
		7,
		42055
	],
	"./nl-BE/_lib/formatDistance/index": [
		42055,
		7,
		42055
	],
	"./nl-BE/_lib/formatDistance/index.js": [
		42055,
		7,
		42055
	],
	"./nl-BE/_lib/formatLong": [
		34558,
		7,
		34558
	],
	"./nl-BE/_lib/formatLong/": [
		34558,
		7,
		34558
	],
	"./nl-BE/_lib/formatLong/index": [
		34558,
		7,
		34558
	],
	"./nl-BE/_lib/formatLong/index.js": [
		34558,
		7,
		34558
	],
	"./nl-BE/_lib/formatRelative": [
		82993,
		7,
		82993
	],
	"./nl-BE/_lib/formatRelative/": [
		82993,
		7,
		82993
	],
	"./nl-BE/_lib/formatRelative/index": [
		82993,
		7,
		82993
	],
	"./nl-BE/_lib/formatRelative/index.js": [
		82993,
		7,
		82993
	],
	"./nl-BE/_lib/localize": [
		9,
		7,
		9
	],
	"./nl-BE/_lib/localize/": [
		9,
		7,
		9
	],
	"./nl-BE/_lib/localize/index": [
		9,
		7,
		9
	],
	"./nl-BE/_lib/localize/index.js": [
		9,
		7,
		9
	],
	"./nl-BE/_lib/match": [
		35264,
		7,
		35264
	],
	"./nl-BE/_lib/match/": [
		35264,
		7,
		35264
	],
	"./nl-BE/_lib/match/index": [
		35264,
		7,
		35264
	],
	"./nl-BE/_lib/match/index.js": [
		35264,
		7,
		35264
	],
	"./nl-BE/index": [
		62205,
		7,
		62205
	],
	"./nl-BE/index.d": [
		20592,
		9,
		20592
	],
	"./nl-BE/index.d.ts": [
		20592,
		9,
		20592
	],
	"./nl-BE/index.js": [
		62205,
		7,
		62205
	],
	"./nl-BE/index.js.flow": [
		96804,
		1,
		96804
	],
	"./nl-BE/package": [
		4919,
		3,
		4919
	],
	"./nl-BE/package.json": [
		4919,
		3,
		4919
	],
	"./nl/": [
		59084,
		9,
		59084
	],
	"./nl/_lib/formatDistance": [
		63384,
		7,
		63384
	],
	"./nl/_lib/formatDistance/": [
		63384,
		7,
		63384
	],
	"./nl/_lib/formatDistance/index": [
		63384,
		7,
		63384
	],
	"./nl/_lib/formatDistance/index.js": [
		63384,
		7,
		63384
	],
	"./nl/_lib/formatLong": [
		74747,
		7,
		74747
	],
	"./nl/_lib/formatLong/": [
		74747,
		7,
		74747
	],
	"./nl/_lib/formatLong/index": [
		74747,
		7,
		74747
	],
	"./nl/_lib/formatLong/index.js": [
		74747,
		7,
		74747
	],
	"./nl/_lib/formatRelative": [
		79363,
		7,
		79363
	],
	"./nl/_lib/formatRelative/": [
		79363,
		7,
		79363
	],
	"./nl/_lib/formatRelative/index": [
		79363,
		7,
		79363
	],
	"./nl/_lib/formatRelative/index.js": [
		79363,
		7,
		79363
	],
	"./nl/_lib/localize": [
		77396,
		7,
		77396
	],
	"./nl/_lib/localize/": [
		77396,
		7,
		77396
	],
	"./nl/_lib/localize/index": [
		77396,
		7,
		77396
	],
	"./nl/_lib/localize/index.js": [
		77396,
		7,
		77396
	],
	"./nl/_lib/match": [
		90951,
		7,
		90951
	],
	"./nl/_lib/match/": [
		90951,
		7,
		90951
	],
	"./nl/_lib/match/index": [
		90951,
		7,
		90951
	],
	"./nl/_lib/match/index.js": [
		90951,
		7,
		90951
	],
	"./nl/index": [
		53906,
		7,
		53906
	],
	"./nl/index.d": [
		34663,
		9,
		34663
	],
	"./nl/index.d.ts": [
		34663,
		9,
		34663
	],
	"./nl/index.js": [
		53906,
		7,
		53906
	],
	"./nl/index.js.flow": [
		84527,
		1,
		84527
	],
	"./nl/package": [
		60210,
		3,
		60210
	],
	"./nl/package.json": [
		60210,
		3,
		60210
	],
	"./nn": [
		51079,
		9,
		51079
	],
	"./nn/": [
		51079,
		9,
		51079
	],
	"./nn/_lib/formatDistance": [
		72744,
		7,
		72744
	],
	"./nn/_lib/formatDistance/": [
		72744,
		7,
		72744
	],
	"./nn/_lib/formatDistance/index": [
		72744,
		7,
		72744
	],
	"./nn/_lib/formatDistance/index.js": [
		72744,
		7,
		72744
	],
	"./nn/_lib/formatLong": [
		55447,
		7,
		55447
	],
	"./nn/_lib/formatLong/": [
		55447,
		7,
		55447
	],
	"./nn/_lib/formatLong/index": [
		55447,
		7,
		55447
	],
	"./nn/_lib/formatLong/index.js": [
		55447,
		7,
		55447
	],
	"./nn/_lib/formatRelative": [
		27726,
		7,
		27726
	],
	"./nn/_lib/formatRelative/": [
		27726,
		7,
		27726
	],
	"./nn/_lib/formatRelative/index": [
		27726,
		7,
		27726
	],
	"./nn/_lib/formatRelative/index.js": [
		27726,
		7,
		27726
	],
	"./nn/_lib/localize": [
		563,
		7,
		563
	],
	"./nn/_lib/localize/": [
		563,
		7,
		563
	],
	"./nn/_lib/localize/index": [
		563,
		7,
		563
	],
	"./nn/_lib/localize/index.js": [
		563,
		7,
		563
	],
	"./nn/_lib/match": [
		56959,
		7,
		56959
	],
	"./nn/_lib/match/": [
		56959,
		7,
		56959
	],
	"./nn/_lib/match/index": [
		56959,
		7,
		56959
	],
	"./nn/_lib/match/index.js": [
		56959,
		7,
		56959
	],
	"./nn/index": [
		39359,
		7,
		39359
	],
	"./nn/index.d": [
		28141,
		9,
		28141
	],
	"./nn/index.d.ts": [
		28141,
		9,
		28141
	],
	"./nn/index.js": [
		39359,
		7,
		39359
	],
	"./nn/index.js.flow": [
		58889,
		1,
		58889
	],
	"./nn/package": [
		76701,
		3,
		76701
	],
	"./nn/package.json": [
		76701,
		3,
		76701
	],
	"./package": [
		19391,
		3,
		19391
	],
	"./package.json": [
		19391,
		3,
		19391
	],
	"./pl": [
		12058,
		9,
		12058
	],
	"./pl/": [
		12058,
		9,
		12058
	],
	"./pl/_lib/formatDistance": [
		4674,
		7,
		4674
	],
	"./pl/_lib/formatDistance/": [
		4674,
		7,
		4674
	],
	"./pl/_lib/formatDistance/index": [
		4674,
		7,
		4674
	],
	"./pl/_lib/formatDistance/index.js": [
		4674,
		7,
		4674
	],
	"./pl/_lib/formatLong": [
		98465,
		7,
		98465
	],
	"./pl/_lib/formatLong/": [
		98465,
		7,
		98465
	],
	"./pl/_lib/formatLong/index": [
		98465,
		7,
		98465
	],
	"./pl/_lib/formatLong/index.js": [
		98465,
		7,
		98465
	],
	"./pl/_lib/formatRelative": [
		18349,
		7,
		18349
	],
	"./pl/_lib/formatRelative/": [
		18349,
		7,
		18349
	],
	"./pl/_lib/formatRelative/index": [
		18349,
		7,
		18349
	],
	"./pl/_lib/formatRelative/index.js": [
		18349,
		7,
		18349
	],
	"./pl/_lib/localize": [
		10730,
		7,
		10730
	],
	"./pl/_lib/localize/": [
		10730,
		7,
		10730
	],
	"./pl/_lib/localize/index": [
		10730,
		7,
		10730
	],
	"./pl/_lib/localize/index.js": [
		10730,
		7,
		10730
	],
	"./pl/_lib/match": [
		19638,
		7,
		19638
	],
	"./pl/_lib/match/": [
		19638,
		7,
		19638
	],
	"./pl/_lib/match/index": [
		19638,
		7,
		19638
	],
	"./pl/_lib/match/index.js": [
		19638,
		7,
		19638
	],
	"./pl/index": [
		86881,
		7,
		86881
	],
	"./pl/index.d": [
		94973,
		9,
		94973
	],
	"./pl/index.d.ts": [
		94973,
		9,
		94973
	],
	"./pl/index.js": [
		86881,
		7,
		86881
	],
	"./pl/index.js.flow": [
		47015,
		1,
		47015
	],
	"./pl/package": [
		24452,
		3,
		24452
	],
	"./pl/package.json": [
		24452,
		3,
		24452
	],
	"./pt": [
		17664,
		9,
		17664
	],
	"./pt-BR": [
		6056,
		9,
		6056
	],
	"./pt-BR/": [
		6056,
		9,
		6056
	],
	"./pt-BR/_lib/formatDistance": [
		51820,
		7,
		51820
	],
	"./pt-BR/_lib/formatDistance/": [
		51820,
		7,
		51820
	],
	"./pt-BR/_lib/formatDistance/index": [
		51820,
		7,
		51820
	],
	"./pt-BR/_lib/formatDistance/index.js": [
		51820,
		7,
		51820
	],
	"./pt-BR/_lib/formatLong": [
		38259,
		7,
		38259
	],
	"./pt-BR/_lib/formatLong/": [
		38259,
		7,
		38259
	],
	"./pt-BR/_lib/formatLong/index": [
		38259,
		7,
		38259
	],
	"./pt-BR/_lib/formatLong/index.js": [
		38259,
		7,
		38259
	],
	"./pt-BR/_lib/formatRelative": [
		67236,
		7,
		67236
	],
	"./pt-BR/_lib/formatRelative/": [
		67236,
		7,
		67236
	],
	"./pt-BR/_lib/formatRelative/index": [
		67236,
		7,
		67236
	],
	"./pt-BR/_lib/formatRelative/index.js": [
		67236,
		7,
		67236
	],
	"./pt-BR/_lib/localize": [
		55004,
		7,
		55004
	],
	"./pt-BR/_lib/localize/": [
		55004,
		7,
		55004
	],
	"./pt-BR/_lib/localize/index": [
		55004,
		7,
		55004
	],
	"./pt-BR/_lib/localize/index.js": [
		55004,
		7,
		55004
	],
	"./pt-BR/_lib/match": [
		40898,
		7,
		40898
	],
	"./pt-BR/_lib/match/": [
		40898,
		7,
		40898
	],
	"./pt-BR/_lib/match/index": [
		40898,
		7,
		40898
	],
	"./pt-BR/_lib/match/index.js": [
		40898,
		7,
		40898
	],
	"./pt-BR/index": [
		51221,
		7,
		51221
	],
	"./pt-BR/index.d": [
		58760,
		9,
		58760
	],
	"./pt-BR/index.d.ts": [
		58760,
		9,
		58760
	],
	"./pt-BR/index.js": [
		51221,
		7,
		51221
	],
	"./pt-BR/index.js.flow": [
		49930,
		1,
		49930
	],
	"./pt-BR/package": [
		83193,
		3,
		83193
	],
	"./pt-BR/package.json": [
		83193,
		3,
		83193
	],
	"./pt/": [
		17664,
		9,
		17664
	],
	"./pt/_lib/formatDistance": [
		38264,
		7,
		38264
	],
	"./pt/_lib/formatDistance/": [
		38264,
		7,
		38264
	],
	"./pt/_lib/formatDistance/index": [
		38264,
		7,
		38264
	],
	"./pt/_lib/formatDistance/index.js": [
		38264,
		7,
		38264
	],
	"./pt/_lib/formatLong": [
		28893,
		7,
		28893
	],
	"./pt/_lib/formatLong/": [
		28893,
		7,
		28893
	],
	"./pt/_lib/formatLong/index": [
		28893,
		7,
		28893
	],
	"./pt/_lib/formatLong/index.js": [
		28893,
		7,
		28893
	],
	"./pt/_lib/formatRelative": [
		64306,
		7,
		64306
	],
	"./pt/_lib/formatRelative/": [
		64306,
		7,
		64306
	],
	"./pt/_lib/formatRelative/index": [
		64306,
		7,
		64306
	],
	"./pt/_lib/formatRelative/index.js": [
		64306,
		7,
		64306
	],
	"./pt/_lib/localize": [
		22052,
		7,
		22052
	],
	"./pt/_lib/localize/": [
		22052,
		7,
		22052
	],
	"./pt/_lib/localize/index": [
		22052,
		7,
		22052
	],
	"./pt/_lib/localize/index.js": [
		22052,
		7,
		22052
	],
	"./pt/_lib/match": [
		16416,
		7,
		16416
	],
	"./pt/_lib/match/": [
		16416,
		7,
		16416
	],
	"./pt/_lib/match/index": [
		16416,
		7,
		16416
	],
	"./pt/_lib/match/index.js": [
		16416,
		7,
		16416
	],
	"./pt/index": [
		4768,
		7,
		4768
	],
	"./pt/index.d": [
		88073,
		9,
		88073
	],
	"./pt/index.d.ts": [
		88073,
		9,
		88073
	],
	"./pt/index.js": [
		4768,
		7,
		4768
	],
	"./pt/index.js.flow": [
		4657,
		1,
		4657
	],
	"./pt/package": [
		77108,
		3,
		77108
	],
	"./pt/package.json": [
		77108,
		3,
		77108
	],
	"./ro": [
		87525,
		9,
		87525
	],
	"./ro/": [
		87525,
		9,
		87525
	],
	"./ro/_lib/formatDistance": [
		75565,
		7,
		75565
	],
	"./ro/_lib/formatDistance/": [
		75565,
		7,
		75565
	],
	"./ro/_lib/formatDistance/index": [
		75565,
		7,
		75565
	],
	"./ro/_lib/formatDistance/index.js": [
		75565,
		7,
		75565
	],
	"./ro/_lib/formatLong": [
		59082,
		7,
		59082
	],
	"./ro/_lib/formatLong/": [
		59082,
		7,
		59082
	],
	"./ro/_lib/formatLong/index": [
		59082,
		7,
		59082
	],
	"./ro/_lib/formatLong/index.js": [
		59082,
		7,
		59082
	],
	"./ro/_lib/formatRelative": [
		97758,
		7,
		97758
	],
	"./ro/_lib/formatRelative/": [
		97758,
		7,
		97758
	],
	"./ro/_lib/formatRelative/index": [
		97758,
		7,
		97758
	],
	"./ro/_lib/formatRelative/index.js": [
		97758,
		7,
		97758
	],
	"./ro/_lib/localize": [
		32362,
		7,
		32362
	],
	"./ro/_lib/localize/": [
		32362,
		7,
		32362
	],
	"./ro/_lib/localize/index": [
		32362,
		7,
		32362
	],
	"./ro/_lib/localize/index.js": [
		32362,
		7,
		32362
	],
	"./ro/_lib/match": [
		10391,
		7,
		10391
	],
	"./ro/_lib/match/": [
		10391,
		7,
		10391
	],
	"./ro/_lib/match/index": [
		10391,
		7,
		10391
	],
	"./ro/_lib/match/index.js": [
		10391,
		7,
		10391
	],
	"./ro/index": [
		21963,
		7,
		21963
	],
	"./ro/index.d": [
		28655,
		9,
		28655
	],
	"./ro/index.d.ts": [
		28655,
		9,
		28655
	],
	"./ro/index.js": [
		21963,
		7,
		21963
	],
	"./ro/index.js.flow": [
		89622,
		1,
		89622
	],
	"./ro/package": [
		64439,
		3,
		64439
	],
	"./ro/package.json": [
		64439,
		3,
		64439
	],
	"./ru": [
		51571,
		9,
		51571
	],
	"./ru/": [
		51571,
		9,
		51571
	],
	"./ru/_lib/formatDistance": [
		63880,
		7,
		63880
	],
	"./ru/_lib/formatDistance/": [
		63880,
		7,
		63880
	],
	"./ru/_lib/formatDistance/index": [
		63880,
		7,
		63880
	],
	"./ru/_lib/formatDistance/index.js": [
		63880,
		7,
		63880
	],
	"./ru/_lib/formatLong": [
		15855,
		7,
		15855
	],
	"./ru/_lib/formatLong/": [
		15855,
		7,
		15855
	],
	"./ru/_lib/formatLong/index": [
		15855,
		7,
		15855
	],
	"./ru/_lib/formatLong/index.js": [
		15855,
		7,
		15855
	],
	"./ru/_lib/formatRelative": [
		10795,
		7,
		10795
	],
	"./ru/_lib/formatRelative/": [
		10795,
		7,
		10795
	],
	"./ru/_lib/formatRelative/index": [
		10795,
		7,
		10795
	],
	"./ru/_lib/formatRelative/index.js": [
		10795,
		7,
		10795
	],
	"./ru/_lib/localize": [
		37109,
		7,
		37109
	],
	"./ru/_lib/localize/": [
		37109,
		7,
		37109
	],
	"./ru/_lib/localize/index": [
		37109,
		7,
		37109
	],
	"./ru/_lib/localize/index.js": [
		37109,
		7,
		37109
	],
	"./ru/_lib/match": [
		98277,
		7,
		98277
	],
	"./ru/_lib/match/": [
		98277,
		7,
		98277
	],
	"./ru/_lib/match/index": [
		98277,
		7,
		98277
	],
	"./ru/_lib/match/index.js": [
		98277,
		7,
		98277
	],
	"./ru/index": [
		31957,
		7,
		31957,
		35604
	],
	"./ru/index.d": [
		29232,
		9,
		29232
	],
	"./ru/index.d.ts": [
		29232,
		9,
		29232
	],
	"./ru/index.js": [
		31957,
		7,
		31957,
		35604
	],
	"./ru/index.js.flow": [
		58272,
		1,
		58272
	],
	"./ru/package": [
		96673,
		3,
		96673
	],
	"./ru/package.json": [
		96673,
		3,
		96673
	],
	"./sk": [
		49322,
		9,
		49322
	],
	"./sk/": [
		49322,
		9,
		49322
	],
	"./sk/_lib/formatDistance": [
		77623,
		7,
		77623
	],
	"./sk/_lib/formatDistance/": [
		77623,
		7,
		77623
	],
	"./sk/_lib/formatDistance/index": [
		77623,
		7,
		77623
	],
	"./sk/_lib/formatDistance/index.js": [
		77623,
		7,
		77623
	],
	"./sk/_lib/formatLong": [
		13670,
		7,
		13670
	],
	"./sk/_lib/formatLong/": [
		13670,
		7,
		13670
	],
	"./sk/_lib/formatLong/index": [
		13670,
		7,
		13670
	],
	"./sk/_lib/formatLong/index.js": [
		13670,
		7,
		13670
	],
	"./sk/_lib/formatRelative": [
		85702,
		7,
		85702
	],
	"./sk/_lib/formatRelative/": [
		85702,
		7,
		85702
	],
	"./sk/_lib/formatRelative/index": [
		85702,
		7,
		85702
	],
	"./sk/_lib/formatRelative/index.js": [
		85702,
		7,
		85702
	],
	"./sk/_lib/localize": [
		68223,
		7,
		68223
	],
	"./sk/_lib/localize/": [
		68223,
		7,
		68223
	],
	"./sk/_lib/localize/index": [
		68223,
		7,
		68223
	],
	"./sk/_lib/localize/index.js": [
		68223,
		7,
		68223
	],
	"./sk/_lib/match": [
		10948,
		7,
		10948
	],
	"./sk/_lib/match/": [
		10948,
		7,
		10948
	],
	"./sk/_lib/match/index": [
		10948,
		7,
		10948
	],
	"./sk/_lib/match/index.js": [
		10948,
		7,
		10948
	],
	"./sk/index": [
		70355,
		7,
		70355
	],
	"./sk/index.d": [
		80255,
		9,
		80255
	],
	"./sk/index.d.ts": [
		80255,
		9,
		80255
	],
	"./sk/index.js": [
		70355,
		7,
		70355
	],
	"./sk/index.js.flow": [
		76340,
		1,
		76340
	],
	"./sk/package": [
		87033,
		3,
		87033
	],
	"./sk/package.json": [
		87033,
		3,
		87033
	],
	"./sl": [
		93226,
		9,
		93226
	],
	"./sl/": [
		93226,
		9,
		93226
	],
	"./sl/_lib/formatDistance": [
		21143,
		7,
		21143
	],
	"./sl/_lib/formatDistance/": [
		21143,
		7,
		21143
	],
	"./sl/_lib/formatDistance/index": [
		21143,
		7,
		21143
	],
	"./sl/_lib/formatDistance/index.js": [
		21143,
		7,
		21143
	],
	"./sl/_lib/formatLong": [
		22838,
		7,
		22838
	],
	"./sl/_lib/formatLong/": [
		22838,
		7,
		22838
	],
	"./sl/_lib/formatLong/index": [
		22838,
		7,
		22838
	],
	"./sl/_lib/formatLong/index.js": [
		22838,
		7,
		22838
	],
	"./sl/_lib/formatRelative": [
		39393,
		7,
		39393
	],
	"./sl/_lib/formatRelative/": [
		39393,
		7,
		39393
	],
	"./sl/_lib/formatRelative/index": [
		39393,
		7,
		39393
	],
	"./sl/_lib/formatRelative/index.js": [
		39393,
		7,
		39393
	],
	"./sl/_lib/localize": [
		73010,
		7,
		73010
	],
	"./sl/_lib/localize/": [
		73010,
		7,
		73010
	],
	"./sl/_lib/localize/index": [
		73010,
		7,
		73010
	],
	"./sl/_lib/localize/index.js": [
		73010,
		7,
		73010
	],
	"./sl/_lib/match": [
		52722,
		7,
		52722
	],
	"./sl/_lib/match/": [
		52722,
		7,
		52722
	],
	"./sl/_lib/match/index": [
		52722,
		7,
		52722
	],
	"./sl/_lib/match/index.js": [
		52722,
		7,
		52722
	],
	"./sl/index": [
		70247,
		7,
		70247
	],
	"./sl/index.d": [
		8034,
		9,
		8034
	],
	"./sl/index.d.ts": [
		8034,
		9,
		8034
	],
	"./sl/index.js": [
		70247,
		7,
		70247
	],
	"./sl/index.js.flow": [
		6266,
		1,
		6266
	],
	"./sl/package": [
		87116,
		3,
		87116
	],
	"./sl/package.json": [
		87116,
		3,
		87116
	],
	"./sq": [
		57851,
		9,
		57851
	],
	"./sq/": [
		57851,
		9,
		57851
	],
	"./sq/_lib/formatDistance": [
		93222,
		7,
		93222
	],
	"./sq/_lib/formatDistance/": [
		93222,
		7,
		93222
	],
	"./sq/_lib/formatDistance/index": [
		93222,
		7,
		93222
	],
	"./sq/_lib/formatDistance/index.js": [
		93222,
		7,
		93222
	],
	"./sq/_lib/formatLong": [
		344,
		7,
		344
	],
	"./sq/_lib/formatLong/": [
		344,
		7,
		344
	],
	"./sq/_lib/formatLong/index": [
		344,
		7,
		344
	],
	"./sq/_lib/formatLong/index.js": [
		344,
		7,
		344
	],
	"./sq/_lib/formatRelative": [
		6688,
		7,
		6688
	],
	"./sq/_lib/formatRelative/": [
		6688,
		7,
		6688
	],
	"./sq/_lib/formatRelative/index": [
		6688,
		7,
		6688
	],
	"./sq/_lib/formatRelative/index.js": [
		6688,
		7,
		6688
	],
	"./sq/_lib/localize": [
		23246,
		7,
		23246
	],
	"./sq/_lib/localize/": [
		23246,
		7,
		23246
	],
	"./sq/_lib/localize/index": [
		23246,
		7,
		23246
	],
	"./sq/_lib/localize/index.js": [
		23246,
		7,
		23246
	],
	"./sq/_lib/match": [
		57062,
		7,
		57062
	],
	"./sq/_lib/match/": [
		57062,
		7,
		57062
	],
	"./sq/_lib/match/index": [
		57062,
		7,
		57062
	],
	"./sq/_lib/match/index.js": [
		57062,
		7,
		57062
	],
	"./sq/index": [
		59949,
		7,
		59949
	],
	"./sq/index.d": [
		49192,
		9,
		49192
	],
	"./sq/index.d.ts": [
		49192,
		9,
		49192
	],
	"./sq/index.js": [
		59949,
		7,
		59949
	],
	"./sq/index.js.flow": [
		69300,
		1,
		69300
	],
	"./sq/package": [
		56883,
		3,
		56883
	],
	"./sq/package.json": [
		56883,
		3,
		56883
	],
	"./sr": [
		33332,
		9,
		33332
	],
	"./sr-Latn": [
		14068,
		9,
		14068
	],
	"./sr-Latn/": [
		14068,
		9,
		14068
	],
	"./sr-Latn/_lib/formatDistance": [
		40790,
		7,
		40790
	],
	"./sr-Latn/_lib/formatDistance/": [
		40790,
		7,
		40790
	],
	"./sr-Latn/_lib/formatDistance/index": [
		40790,
		7,
		40790
	],
	"./sr-Latn/_lib/formatDistance/index.js": [
		40790,
		7,
		40790
	],
	"./sr-Latn/_lib/formatLong": [
		26464,
		7,
		26464
	],
	"./sr-Latn/_lib/formatLong/": [
		26464,
		7,
		26464
	],
	"./sr-Latn/_lib/formatLong/index": [
		26464,
		7,
		26464
	],
	"./sr-Latn/_lib/formatLong/index.js": [
		26464,
		7,
		26464
	],
	"./sr-Latn/_lib/formatRelative": [
		79174,
		7,
		79174
	],
	"./sr-Latn/_lib/formatRelative/": [
		79174,
		7,
		79174
	],
	"./sr-Latn/_lib/formatRelative/index": [
		79174,
		7,
		79174
	],
	"./sr-Latn/_lib/formatRelative/index.js": [
		79174,
		7,
		79174
	],
	"./sr-Latn/_lib/localize": [
		38332,
		7,
		38332
	],
	"./sr-Latn/_lib/localize/": [
		38332,
		7,
		38332
	],
	"./sr-Latn/_lib/localize/index": [
		38332,
		7,
		38332
	],
	"./sr-Latn/_lib/localize/index.js": [
		38332,
		7,
		38332
	],
	"./sr-Latn/_lib/match": [
		7628,
		7,
		7628
	],
	"./sr-Latn/_lib/match/": [
		7628,
		7,
		7628
	],
	"./sr-Latn/_lib/match/index": [
		7628,
		7,
		7628
	],
	"./sr-Latn/_lib/match/index.js": [
		7628,
		7,
		7628
	],
	"./sr-Latn/index": [
		99228,
		7,
		37515
	],
	"./sr-Latn/index.d": [
		85775,
		9,
		85775
	],
	"./sr-Latn/index.d.ts": [
		85775,
		9,
		85775
	],
	"./sr-Latn/index.js": [
		99228,
		7,
		37515
	],
	"./sr-Latn/index.js.flow": [
		5531,
		1,
		5531
	],
	"./sr-Latn/package": [
		49243,
		3,
		49243
	],
	"./sr-Latn/package.json": [
		49243,
		3,
		49243
	],
	"./sr/": [
		33332,
		9,
		33332
	],
	"./sr/_lib/formatDistance": [
		13716,
		7,
		13716
	],
	"./sr/_lib/formatDistance/": [
		13716,
		7,
		13716
	],
	"./sr/_lib/formatDistance/index": [
		13716,
		7,
		13716
	],
	"./sr/_lib/formatDistance/index.js": [
		13716,
		7,
		13716
	],
	"./sr/_lib/formatLong": [
		56872,
		7,
		56872
	],
	"./sr/_lib/formatLong/": [
		56872,
		7,
		56872
	],
	"./sr/_lib/formatLong/index": [
		56872,
		7,
		56872
	],
	"./sr/_lib/formatLong/index.js": [
		56872,
		7,
		56872
	],
	"./sr/_lib/formatRelative": [
		39398,
		7,
		39398
	],
	"./sr/_lib/formatRelative/": [
		39398,
		7,
		39398
	],
	"./sr/_lib/formatRelative/index": [
		39398,
		7,
		39398
	],
	"./sr/_lib/formatRelative/index.js": [
		39398,
		7,
		39398
	],
	"./sr/_lib/localize": [
		13494,
		7,
		13494
	],
	"./sr/_lib/localize/": [
		13494,
		7,
		13494
	],
	"./sr/_lib/localize/index": [
		13494,
		7,
		13494
	],
	"./sr/_lib/localize/index.js": [
		13494,
		7,
		13494
	],
	"./sr/_lib/match": [
		48586,
		7,
		48586
	],
	"./sr/_lib/match/": [
		48586,
		7,
		48586
	],
	"./sr/_lib/match/index": [
		48586,
		7,
		48586
	],
	"./sr/_lib/match/index.js": [
		48586,
		7,
		48586
	],
	"./sr/index": [
		56648,
		7,
		56648
	],
	"./sr/index.d": [
		68764,
		9,
		68764
	],
	"./sr/index.d.ts": [
		68764,
		9,
		68764
	],
	"./sr/index.js": [
		56648,
		7,
		56648
	],
	"./sr/index.js.flow": [
		60219,
		1,
		60219
	],
	"./sr/package": [
		77567,
		3,
		77567
	],
	"./sr/package.json": [
		77567,
		3,
		77567
	],
	"./sv": [
		47309,
		9,
		47309
	],
	"./sv/": [
		47309,
		9,
		47309
	],
	"./sv/_lib/formatDistance": [
		35164,
		7,
		35164
	],
	"./sv/_lib/formatDistance/": [
		35164,
		7,
		35164
	],
	"./sv/_lib/formatDistance/index": [
		35164,
		7,
		35164
	],
	"./sv/_lib/formatDistance/index.js": [
		35164,
		7,
		35164
	],
	"./sv/_lib/formatLong": [
		83421,
		7,
		83421
	],
	"./sv/_lib/formatLong/": [
		83421,
		7,
		83421
	],
	"./sv/_lib/formatLong/index": [
		83421,
		7,
		83421
	],
	"./sv/_lib/formatLong/index.js": [
		83421,
		7,
		83421
	],
	"./sv/_lib/formatRelative": [
		42277,
		7,
		42277
	],
	"./sv/_lib/formatRelative/": [
		42277,
		7,
		42277
	],
	"./sv/_lib/formatRelative/index": [
		42277,
		7,
		42277
	],
	"./sv/_lib/formatRelative/index.js": [
		42277,
		7,
		42277
	],
	"./sv/_lib/localize": [
		71316,
		7,
		71316
	],
	"./sv/_lib/localize/": [
		71316,
		7,
		71316
	],
	"./sv/_lib/localize/index": [
		71316,
		7,
		71316
	],
	"./sv/_lib/localize/index.js": [
		71316,
		7,
		71316
	],
	"./sv/_lib/match": [
		25913,
		7,
		25913
	],
	"./sv/_lib/match/": [
		25913,
		7,
		25913
	],
	"./sv/_lib/match/index": [
		25913,
		7,
		25913
	],
	"./sv/_lib/match/index.js": [
		25913,
		7,
		25913
	],
	"./sv/index": [
		32394,
		7,
		32394
	],
	"./sv/index.d": [
		30820,
		9,
		30820
	],
	"./sv/index.d.ts": [
		30820,
		9,
		30820
	],
	"./sv/index.js": [
		32394,
		7,
		32394
	],
	"./sv/index.js.flow": [
		54685,
		1,
		54685
	],
	"./sv/package": [
		53985,
		3,
		53985
	],
	"./sv/package.json": [
		53985,
		3,
		53985
	],
	"./ta": [
		32631,
		9,
		32631
	],
	"./ta/": [
		32631,
		9,
		32631
	],
	"./ta/_lib/formatDistance": [
		60682,
		7,
		60682
	],
	"./ta/_lib/formatDistance/": [
		60682,
		7,
		60682
	],
	"./ta/_lib/formatDistance/index": [
		60682,
		7,
		60682
	],
	"./ta/_lib/formatDistance/index.js": [
		60682,
		7,
		60682
	],
	"./ta/_lib/formatLong": [
		76198,
		7,
		76198
	],
	"./ta/_lib/formatLong/": [
		76198,
		7,
		76198
	],
	"./ta/_lib/formatLong/index": [
		76198,
		7,
		76198
	],
	"./ta/_lib/formatLong/index.js": [
		76198,
		7,
		76198
	],
	"./ta/_lib/formatRelative": [
		75283,
		7,
		75283
	],
	"./ta/_lib/formatRelative/": [
		75283,
		7,
		75283
	],
	"./ta/_lib/formatRelative/index": [
		75283,
		7,
		75283
	],
	"./ta/_lib/formatRelative/index.js": [
		75283,
		7,
		75283
	],
	"./ta/_lib/localize": [
		82229,
		7,
		82229
	],
	"./ta/_lib/localize/": [
		82229,
		7,
		82229
	],
	"./ta/_lib/localize/index": [
		82229,
		7,
		82229
	],
	"./ta/_lib/localize/index.js": [
		82229,
		7,
		82229
	],
	"./ta/_lib/match": [
		88120,
		7,
		88120
	],
	"./ta/_lib/match/": [
		88120,
		7,
		88120
	],
	"./ta/_lib/match/index": [
		88120,
		7,
		88120
	],
	"./ta/_lib/match/index.js": [
		88120,
		7,
		88120
	],
	"./ta/index": [
		28336,
		7,
		28336,
		10146
	],
	"./ta/index.d": [
		1083,
		9,
		1083
	],
	"./ta/index.d.ts": [
		1083,
		9,
		1083
	],
	"./ta/index.js": [
		28336,
		7,
		28336,
		10146
	],
	"./ta/index.js.flow": [
		83142,
		1,
		83142
	],
	"./ta/package": [
		51543,
		3,
		51543
	],
	"./ta/package.json": [
		51543,
		3,
		51543
	],
	"./te": [
		72389,
		9,
		72389
	],
	"./te/": [
		72389,
		9,
		72389
	],
	"./te/_lib/formatDistance": [
		14468,
		7,
		14468
	],
	"./te/_lib/formatDistance/": [
		14468,
		7,
		14468
	],
	"./te/_lib/formatDistance/index": [
		14468,
		7,
		14468
	],
	"./te/_lib/formatDistance/index.js": [
		14468,
		7,
		14468
	],
	"./te/_lib/formatLong": [
		93312,
		7,
		93312
	],
	"./te/_lib/formatLong/": [
		93312,
		7,
		93312
	],
	"./te/_lib/formatLong/index": [
		93312,
		7,
		93312
	],
	"./te/_lib/formatLong/index.js": [
		93312,
		7,
		93312
	],
	"./te/_lib/formatRelative": [
		63817,
		7,
		63817
	],
	"./te/_lib/formatRelative/": [
		63817,
		7,
		63817
	],
	"./te/_lib/formatRelative/index": [
		63817,
		7,
		63817
	],
	"./te/_lib/formatRelative/index.js": [
		63817,
		7,
		63817
	],
	"./te/_lib/localize": [
		42573,
		7,
		42573
	],
	"./te/_lib/localize/": [
		42573,
		7,
		42573
	],
	"./te/_lib/localize/index": [
		42573,
		7,
		42573
	],
	"./te/_lib/localize/index.js": [
		42573,
		7,
		42573
	],
	"./te/_lib/match": [
		17738,
		7,
		17738
	],
	"./te/_lib/match/": [
		17738,
		7,
		17738
	],
	"./te/_lib/match/index": [
		17738,
		7,
		17738
	],
	"./te/_lib/match/index.js": [
		17738,
		7,
		17738
	],
	"./te/index": [
		45284,
		7,
		45284
	],
	"./te/index.d": [
		76771,
		9,
		76771
	],
	"./te/index.d.ts": [
		76771,
		9,
		76771
	],
	"./te/index.js": [
		45284,
		7,
		45284
	],
	"./te/index.js.flow": [
		57590,
		1,
		57590
	],
	"./te/package": [
		17212,
		3,
		17212
	],
	"./te/package.json": [
		17212,
		3,
		17212
	],
	"./th": [
		98298,
		9,
		98298
	],
	"./th/": [
		98298,
		9,
		98298
	],
	"./th/_lib/formatDistance": [
		77762,
		7,
		77762
	],
	"./th/_lib/formatDistance/": [
		77762,
		7,
		77762
	],
	"./th/_lib/formatDistance/index": [
		77762,
		7,
		77762
	],
	"./th/_lib/formatDistance/index.js": [
		77762,
		7,
		77762
	],
	"./th/_lib/formatLong": [
		81583,
		7,
		81583
	],
	"./th/_lib/formatLong/": [
		81583,
		7,
		81583
	],
	"./th/_lib/formatLong/index": [
		81583,
		7,
		81583
	],
	"./th/_lib/formatLong/index.js": [
		81583,
		7,
		81583
	],
	"./th/_lib/formatRelative": [
		59855,
		7,
		59855
	],
	"./th/_lib/formatRelative/": [
		59855,
		7,
		59855
	],
	"./th/_lib/formatRelative/index": [
		59855,
		7,
		59855
	],
	"./th/_lib/formatRelative/index.js": [
		59855,
		7,
		59855
	],
	"./th/_lib/localize": [
		88898,
		7,
		88898
	],
	"./th/_lib/localize/": [
		88898,
		7,
		88898
	],
	"./th/_lib/localize/index": [
		88898,
		7,
		88898
	],
	"./th/_lib/localize/index.js": [
		88898,
		7,
		88898
	],
	"./th/_lib/match": [
		16901,
		7,
		16901
	],
	"./th/_lib/match/": [
		16901,
		7,
		16901
	],
	"./th/_lib/match/index": [
		16901,
		7,
		16901
	],
	"./th/_lib/match/index.js": [
		16901,
		7,
		16901
	],
	"./th/index": [
		83202,
		7,
		83202
	],
	"./th/index.d": [
		19263,
		9,
		19263
	],
	"./th/index.d.ts": [
		19263,
		9,
		19263
	],
	"./th/index.js": [
		83202,
		7,
		83202
	],
	"./th/index.js.flow": [
		95794,
		1,
		95794
	],
	"./th/package": [
		34148,
		3,
		34148
	],
	"./th/package.json": [
		34148,
		3,
		34148
	],
	"./tr": [
		36309,
		9,
		36309
	],
	"./tr/": [
		36309,
		9,
		36309
	],
	"./tr/_lib/formatDistance": [
		74120,
		7,
		74120
	],
	"./tr/_lib/formatDistance/": [
		74120,
		7,
		74120
	],
	"./tr/_lib/formatDistance/index": [
		74120,
		7,
		74120
	],
	"./tr/_lib/formatDistance/index.js": [
		74120,
		7,
		74120
	],
	"./tr/_lib/formatLong": [
		40489,
		7,
		40489
	],
	"./tr/_lib/formatLong/": [
		40489,
		7,
		40489
	],
	"./tr/_lib/formatLong/index": [
		40489,
		7,
		40489
	],
	"./tr/_lib/formatLong/index.js": [
		40489,
		7,
		40489
	],
	"./tr/_lib/formatRelative": [
		94945,
		7,
		94945
	],
	"./tr/_lib/formatRelative/": [
		94945,
		7,
		94945
	],
	"./tr/_lib/formatRelative/index": [
		94945,
		7,
		94945
	],
	"./tr/_lib/formatRelative/index.js": [
		94945,
		7,
		94945
	],
	"./tr/_lib/localize": [
		37717,
		7,
		37717
	],
	"./tr/_lib/localize/": [
		37717,
		7,
		37717
	],
	"./tr/_lib/localize/index": [
		37717,
		7,
		37717
	],
	"./tr/_lib/localize/index.js": [
		37717,
		7,
		37717
	],
	"./tr/_lib/match": [
		149,
		7,
		149
	],
	"./tr/_lib/match/": [
		149,
		7,
		149
	],
	"./tr/_lib/match/index": [
		149,
		7,
		149
	],
	"./tr/_lib/match/index.js": [
		149,
		7,
		149
	],
	"./tr/index": [
		8847,
		7,
		8847
	],
	"./tr/index.d": [
		48674,
		9,
		48674
	],
	"./tr/index.d.ts": [
		48674,
		9,
		48674
	],
	"./tr/index.js": [
		8847,
		7,
		8847
	],
	"./tr/index.js.flow": [
		95091,
		1,
		95091
	],
	"./tr/package": [
		93078,
		3,
		93078
	],
	"./tr/package.json": [
		93078,
		3,
		93078
	],
	"./types": [
		95055,
		7,
		95055
	],
	"./types.js": [
		95055,
		7,
		95055
	],
	"./ug": [
		250,
		9,
		250
	],
	"./ug/": [
		250,
		9,
		250
	],
	"./ug/_lib/formatDistance": [
		60987,
		7,
		60987
	],
	"./ug/_lib/formatDistance/": [
		60987,
		7,
		60987
	],
	"./ug/_lib/formatDistance/index": [
		60987,
		7,
		60987
	],
	"./ug/_lib/formatDistance/index.js": [
		60987,
		7,
		60987
	],
	"./ug/_lib/formatLong": [
		42722,
		7,
		42722
	],
	"./ug/_lib/formatLong/": [
		42722,
		7,
		42722
	],
	"./ug/_lib/formatLong/index": [
		42722,
		7,
		42722
	],
	"./ug/_lib/formatLong/index.js": [
		42722,
		7,
		42722
	],
	"./ug/_lib/formatRelative": [
		39977,
		7,
		39977
	],
	"./ug/_lib/formatRelative/": [
		39977,
		7,
		39977
	],
	"./ug/_lib/formatRelative/index": [
		39977,
		7,
		39977
	],
	"./ug/_lib/formatRelative/index.js": [
		39977,
		7,
		39977
	],
	"./ug/_lib/localize": [
		43629,
		7,
		43629
	],
	"./ug/_lib/localize/": [
		43629,
		7,
		43629
	],
	"./ug/_lib/localize/index": [
		43629,
		7,
		43629
	],
	"./ug/_lib/localize/index.js": [
		43629,
		7,
		43629
	],
	"./ug/_lib/match": [
		36751,
		7,
		36751
	],
	"./ug/_lib/match/": [
		36751,
		7,
		36751
	],
	"./ug/_lib/match/index": [
		36751,
		7,
		36751
	],
	"./ug/_lib/match/index.js": [
		36751,
		7,
		36751
	],
	"./ug/index": [
		57653,
		7,
		57653
	],
	"./ug/index.d": [
		23448,
		9,
		23448
	],
	"./ug/index.d.ts": [
		23448,
		9,
		23448
	],
	"./ug/index.js": [
		57653,
		7,
		57653
	],
	"./ug/index.js.flow": [
		4178,
		1,
		4178
	],
	"./ug/package": [
		50866,
		3,
		50866
	],
	"./ug/package.json": [
		50866,
		3,
		50866
	],
	"./uk": [
		28171,
		9,
		28171
	],
	"./uk/": [
		28171,
		9,
		28171
	],
	"./uk/_lib/formatDistance": [
		15500,
		7,
		15500
	],
	"./uk/_lib/formatDistance/": [
		15500,
		7,
		15500
	],
	"./uk/_lib/formatDistance/index": [
		15500,
		7,
		15500
	],
	"./uk/_lib/formatDistance/index.js": [
		15500,
		7,
		15500
	],
	"./uk/_lib/formatLong": [
		76621,
		7,
		76621
	],
	"./uk/_lib/formatLong/": [
		76621,
		7,
		76621
	],
	"./uk/_lib/formatLong/index": [
		76621,
		7,
		76621
	],
	"./uk/_lib/formatLong/index.js": [
		76621,
		7,
		76621
	],
	"./uk/_lib/formatRelative": [
		47211,
		7,
		47211
	],
	"./uk/_lib/formatRelative/": [
		47211,
		7,
		47211
	],
	"./uk/_lib/formatRelative/index": [
		47211,
		7,
		47211
	],
	"./uk/_lib/formatRelative/index.js": [
		47211,
		7,
		47211
	],
	"./uk/_lib/localize": [
		47968,
		7,
		47968
	],
	"./uk/_lib/localize/": [
		47968,
		7,
		47968
	],
	"./uk/_lib/localize/index": [
		47968,
		7,
		47968
	],
	"./uk/_lib/localize/index.js": [
		47968,
		7,
		47968
	],
	"./uk/_lib/match": [
		39550,
		7,
		39550
	],
	"./uk/_lib/match/": [
		39550,
		7,
		39550
	],
	"./uk/_lib/match/index": [
		39550,
		7,
		39550
	],
	"./uk/_lib/match/index.js": [
		39550,
		7,
		39550
	],
	"./uk/index": [
		61667,
		7,
		61667,
		70320
	],
	"./uk/index.d": [
		61870,
		9,
		61870
	],
	"./uk/index.d.ts": [
		61870,
		9,
		61870
	],
	"./uk/index.js": [
		61667,
		7,
		61667,
		70320
	],
	"./uk/index.js.flow": [
		86814,
		1,
		86814
	],
	"./uk/package": [
		76730,
		3,
		76730
	],
	"./uk/package.json": [
		76730,
		3,
		76730
	],
	"./uz": [
		40294,
		9,
		40294
	],
	"./uz/": [
		40294,
		9,
		40294
	],
	"./uz/_lib/formatDistance": [
		12843,
		7,
		12843
	],
	"./uz/_lib/formatDistance/": [
		12843,
		7,
		12843
	],
	"./uz/_lib/formatDistance/index": [
		12843,
		7,
		12843
	],
	"./uz/_lib/formatDistance/index.js": [
		12843,
		7,
		12843
	],
	"./uz/_lib/formatLong": [
		50979,
		7,
		50979
	],
	"./uz/_lib/formatLong/": [
		50979,
		7,
		50979
	],
	"./uz/_lib/formatLong/index": [
		50979,
		7,
		50979
	],
	"./uz/_lib/formatLong/index.js": [
		50979,
		7,
		50979
	],
	"./uz/_lib/formatRelative": [
		47168,
		7,
		47168
	],
	"./uz/_lib/formatRelative/": [
		47168,
		7,
		47168
	],
	"./uz/_lib/formatRelative/index": [
		47168,
		7,
		47168
	],
	"./uz/_lib/formatRelative/index.js": [
		47168,
		7,
		47168
	],
	"./uz/_lib/localize": [
		40966,
		7,
		40966
	],
	"./uz/_lib/localize/": [
		40966,
		7,
		40966
	],
	"./uz/_lib/localize/index": [
		40966,
		7,
		40966
	],
	"./uz/_lib/localize/index.js": [
		40966,
		7,
		40966
	],
	"./uz/_lib/match": [
		46642,
		7,
		46642
	],
	"./uz/_lib/match/": [
		46642,
		7,
		46642
	],
	"./uz/_lib/match/index": [
		46642,
		7,
		46642
	],
	"./uz/_lib/match/index.js": [
		46642,
		7,
		46642
	],
	"./uz/index": [
		88505,
		7,
		88505
	],
	"./uz/index.d": [
		73362,
		9,
		73362
	],
	"./uz/index.d.ts": [
		73362,
		9,
		73362
	],
	"./uz/index.js": [
		88505,
		7,
		88505
	],
	"./uz/index.js.flow": [
		84006,
		1,
		84006
	],
	"./uz/package": [
		61155,
		3,
		61155
	],
	"./uz/package.json": [
		61155,
		3,
		61155
	],
	"./vi": [
		12156,
		9,
		12156
	],
	"./vi/": [
		12156,
		9,
		12156
	],
	"./vi/_lib/formatDistance": [
		96085,
		7,
		96085
	],
	"./vi/_lib/formatDistance/": [
		96085,
		7,
		96085
	],
	"./vi/_lib/formatDistance/index": [
		96085,
		7,
		96085
	],
	"./vi/_lib/formatDistance/index.js": [
		96085,
		7,
		96085
	],
	"./vi/_lib/formatLong": [
		77897,
		7,
		77897
	],
	"./vi/_lib/formatLong/": [
		77897,
		7,
		77897
	],
	"./vi/_lib/formatLong/index": [
		77897,
		7,
		77897
	],
	"./vi/_lib/formatLong/index.js": [
		77897,
		7,
		77897
	],
	"./vi/_lib/formatRelative": [
		23904,
		7,
		23904
	],
	"./vi/_lib/formatRelative/": [
		23904,
		7,
		23904
	],
	"./vi/_lib/formatRelative/index": [
		23904,
		7,
		23904
	],
	"./vi/_lib/formatRelative/index.js": [
		23904,
		7,
		23904
	],
	"./vi/_lib/localize": [
		96590,
		7,
		96590
	],
	"./vi/_lib/localize/": [
		96590,
		7,
		96590
	],
	"./vi/_lib/localize/index": [
		96590,
		7,
		96590
	],
	"./vi/_lib/localize/index.js": [
		96590,
		7,
		96590
	],
	"./vi/_lib/match": [
		80162,
		7,
		80162
	],
	"./vi/_lib/match/": [
		80162,
		7,
		80162
	],
	"./vi/_lib/match/index": [
		80162,
		7,
		80162
	],
	"./vi/_lib/match/index.js": [
		80162,
		7,
		80162
	],
	"./vi/index": [
		73825,
		7,
		73825
	],
	"./vi/index.d": [
		63151,
		9,
		63151
	],
	"./vi/index.d.ts": [
		63151,
		9,
		63151
	],
	"./vi/index.js": [
		73825,
		7,
		73825
	],
	"./vi/index.js.flow": [
		20332,
		1,
		20332
	],
	"./vi/package": [
		89517,
		3,
		89517
	],
	"./vi/package.json": [
		89517,
		3,
		89517
	],
	"./zh-CN": [
		37103,
		9,
		37103
	],
	"./zh-CN/": [
		37103,
		9,
		37103
	],
	"./zh-CN/_lib/formatDistance": [
		45208,
		7,
		45208
	],
	"./zh-CN/_lib/formatDistance/": [
		45208,
		7,
		45208
	],
	"./zh-CN/_lib/formatDistance/index": [
		45208,
		7,
		45208
	],
	"./zh-CN/_lib/formatDistance/index.js": [
		45208,
		7,
		45208
	],
	"./zh-CN/_lib/formatLong": [
		90519,
		7,
		90519
	],
	"./zh-CN/_lib/formatLong/": [
		90519,
		7,
		90519
	],
	"./zh-CN/_lib/formatLong/index": [
		90519,
		7,
		90519
	],
	"./zh-CN/_lib/formatLong/index.js": [
		90519,
		7,
		90519
	],
	"./zh-CN/_lib/formatRelative": [
		33720,
		7,
		33720
	],
	"./zh-CN/_lib/formatRelative/": [
		33720,
		7,
		33720
	],
	"./zh-CN/_lib/formatRelative/index": [
		33720,
		7,
		33720
	],
	"./zh-CN/_lib/formatRelative/index.js": [
		33720,
		7,
		33720
	],
	"./zh-CN/_lib/localize": [
		18107,
		7,
		18107
	],
	"./zh-CN/_lib/localize/": [
		18107,
		7,
		18107
	],
	"./zh-CN/_lib/localize/index": [
		18107,
		7,
		18107
	],
	"./zh-CN/_lib/localize/index.js": [
		18107,
		7,
		18107
	],
	"./zh-CN/_lib/match": [
		22373,
		7,
		22373
	],
	"./zh-CN/_lib/match/": [
		22373,
		7,
		22373
	],
	"./zh-CN/_lib/match/index": [
		22373,
		7,
		22373
	],
	"./zh-CN/_lib/match/index.js": [
		22373,
		7,
		22373
	],
	"./zh-CN/index": [
		28379,
		7,
		28379
	],
	"./zh-CN/index.d": [
		95864,
		9,
		95864
	],
	"./zh-CN/index.d.ts": [
		95864,
		9,
		95864
	],
	"./zh-CN/index.js": [
		28379,
		7,
		28379
	],
	"./zh-CN/index.js.flow": [
		67167,
		1,
		67167
	],
	"./zh-CN/package": [
		18692,
		3,
		18692
	],
	"./zh-CN/package.json": [
		18692,
		3,
		18692
	],
	"./zh-TW": [
		11419,
		9,
		11419
	],
	"./zh-TW/": [
		11419,
		9,
		11419
	],
	"./zh-TW/_lib/formatDistance": [
		73412,
		7,
		73412
	],
	"./zh-TW/_lib/formatDistance/": [
		73412,
		7,
		73412
	],
	"./zh-TW/_lib/formatDistance/index": [
		73412,
		7,
		73412
	],
	"./zh-TW/_lib/formatDistance/index.js": [
		73412,
		7,
		73412
	],
	"./zh-TW/_lib/formatLong": [
		29882,
		7,
		29882
	],
	"./zh-TW/_lib/formatLong/": [
		29882,
		7,
		29882
	],
	"./zh-TW/_lib/formatLong/index": [
		29882,
		7,
		29882
	],
	"./zh-TW/_lib/formatLong/index.js": [
		29882,
		7,
		29882
	],
	"./zh-TW/_lib/formatRelative": [
		3634,
		7,
		3634
	],
	"./zh-TW/_lib/formatRelative/": [
		3634,
		7,
		3634
	],
	"./zh-TW/_lib/formatRelative/index": [
		3634,
		7,
		3634
	],
	"./zh-TW/_lib/formatRelative/index.js": [
		3634,
		7,
		3634
	],
	"./zh-TW/_lib/localize": [
		6377,
		7,
		6377
	],
	"./zh-TW/_lib/localize/": [
		6377,
		7,
		6377
	],
	"./zh-TW/_lib/localize/index": [
		6377,
		7,
		6377
	],
	"./zh-TW/_lib/localize/index.js": [
		6377,
		7,
		6377
	],
	"./zh-TW/_lib/match": [
		52418,
		7,
		52418
	],
	"./zh-TW/_lib/match/": [
		52418,
		7,
		52418
	],
	"./zh-TW/_lib/match/index": [
		52418,
		7,
		52418
	],
	"./zh-TW/_lib/match/index.js": [
		52418,
		7,
		52418
	],
	"./zh-TW/index": [
		37976,
		7,
		37976
	],
	"./zh-TW/index.d": [
		68670,
		9,
		68670
	],
	"./zh-TW/index.d.ts": [
		68670,
		9,
		68670
	],
	"./zh-TW/index.js": [
		37976,
		7,
		37976
	],
	"./zh-TW/index.js.flow": [
		36965,
		1,
		36965
	],
	"./zh-TW/package": [
		92198,
		3,
		92198
	],
	"./zh-TW/package.json": [
		92198,
		3,
		92198
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 38750;
module.exports = webpackAsyncContext;